import {
  bookingStatusEnum,
  BookingTagEnum,
  collectFieldTypeEnum,
  guestStage,
  guestTagEnum,
  languageEnum,
  serviceEnum,
} from "./enums";
import {actionParams, triggerParams} from "./specs";
import {buildGuestFilterUrl, capitalize} from "utilities/helperFunctions";
import _ from "lodash";
import {
  Accessible,
  AccountBalance,
  AcUnit,
  Alarm,
  ArrowUpwardRounded,
  BeachAccess,
  ChildCare,
  DirectionsBike,
  DirectionsBus,
  DirectionsCar,
  Event,
  ExitToApp,
  Fastfood,
  FitnessCenter,
  Gavel,
  Home,
  Info,
  LibraryBooks,
  LocalBar,
  LocalCafe,
  LocalHospital,
  LocalLaundryService,
  LocalParking,
  LocalPharmacy,
  LocalTaxi,
  Map,
  MeetingRoom,
  MoneyRounded,
  MusicNote,
  NaturePeople,
  OutdoorGrill,
  PersonPin,
  Pets,
  Phone,
  Pool,
  Restaurant,
  Security,
  SentimentDissatisfiedRounded,
  ShoppingCart,
  SmokeFree,
  SmokingRooms,
  Spa,
  Terrain,
  Tv,
  VpnKey,
  WbSunny,
  Whatshot,
  Wifi,
  WorkOutline,
} from "@material-ui/icons";
import React from "react";

let now = Date.now();
let startDay = new Date().setHours(0, 0, 0, 0);
let endDay = new Date().setHours(23, 59, 59, 999);

// CONFIG
export const defaultImage =
  "https://specials-images.forbesimg.com/imageserve/1026205392/960x0.jpg?fit=scale";

export const googleapis = {
  maps: "https://maps.googleapis.com/maps/api/js?key=",
  search: "https://maps.googleapis.com/maps/api/geocode/json?key=",
  translate: "https://translation.googleapis.com/language/translate/v2?key=",
};

export const otaIcons = (guest = {}, selectedGuestId) => {
  const iconStyles = {
    width: 15,
    height: 15,
    objectFit: "contain",
    filter: "none",
  };

  const getIconStyle = (isSelected) => ({
    ...iconStyles,
    filter: isSelected ? "brightness(0) invert(1)" : "none",
  });

  return {
    VRBO: (
      <img
        key="vrbo"
        alt="vrbo logo"
        style={getIconStyle(selectedGuestId === guest.guest_id)}
        src={require("assets/icons/channels/vrbo.svg")}
      />
    ),
    Airbnb: (
      <img
        key="airbnb"
        alt="airbnb logo"
        style={getIconStyle(selectedGuestId === guest.guest_id)}
        src={require("assets/icons/channels/airbnb.svg")}
      />
    ),
    Expedia: (
      <img
        key="expedia"
        alt="expedia logo"
        style={getIconStyle(selectedGuestId === guest.guest_id)}
        src={require("assets/icons/channels/expedia.svg")}
      />
    ),
    Google: (
      <img
        key="google"
        alt="google logo"
        style={getIconStyle(selectedGuestId === guest.guest_id)}
        src={require("assets/icons/channels/google.svg")}
      />
    ),
    "Booking.com": (
      <img
        key="bookingcom"
        alt="bookingcom logo"
        style={getIconStyle(selectedGuestId === guest.guest_id)}
        src={require("assets/icons/channels/bookingcom.svg")}
      />
    ),
  };
};

export const experienceEditorActions = [
  "airbnb",
  "SMS",
  "email",
  "whatsapp",
  "webhook",
  "ota_email",
];

export const channelEmails = {
  VRBO: "vrbo.com",
  "Home Away": "homeaway.com",
  "Booking.com": "booking.com",
  Expedia: "expedia.com",
};

export const PMS_CONSTS = {
  bks: {
    params: {
      scope: [
        "bookings_read",
        "rentals_read",
        "inbox_write",
        "clients_read",
        "rates_read",
        "payments_read",
        "inquiries_write",
        "bookings_write",
      ].join(" "),
      redirect_uri: window.location.origin + "/admin/channel_auth/bks",
      response_type: "code",
    },
    app_client_id:
      "6705fda170cdef2862d310aca2f43b1a34d470c5e51d7984b27cd3b37015b6af",
    dev_client_id:
      "78a389e0dca57170259e519d235fa9123db3b6b181b322bece9cf0e0fbcecd13",
    authorization_url: `https://www.bookingsync.com/oauth/authorize`,
  },
};

export const validImageTypes = [
  ".bmp",
  ".gif",
  ".svg",
  ".png",
  ".jpeg",
  ".jpg",
  ".ico",
  ".svgz",
  ".webp",
];

export const currencies = ["CAD", "USD", "EUR", "GBP", "MXN"];
export const maxImageSize = 10; //MB
export const maxCompressionImageSize = 2000000; //2mb in bytes
export const allowedImagesRange = [1, 50]; // [min, max]
export const intervals = ["day", "week", "month", "year"];

export const maxAllowedStartValues = {
  day: 30,
  week: 52,
  month: 12,
  year: 2,
};

export const conditionsOnlyFields = [
  "booking_lead_time",
  "unanswered_messages",
  "unread_messages",
  "listing_active",
  "listing_group_id",
  "listing_tags",
  "sentiment",
];

export const invalidPaymentPlans = ["sus", "new", "pay_now", "cncl"];

export const objectMapper = {
  booking: [
    "bookings",
    {
      keyField: ["booking_id", "listing_id", "guest_id"],
      multipleKeys: true,
      keyToGroupBy: "booking_id",
    },
  ],
  guest: ["guests", "guest_id"],
  message: "messages",
  listing: ["house_data", "listing_id"],
  listing_content: ["house_data.listing_content", "listing_id"],
  listing_ranges: ["house_data.listing_ranges", "listing_id"],
  listing_chatbot: ["house_data.chatbot_props", "listing_id"],
  automessage: [
    "automessages",
    {
      keyField: "id",
      multipleKeys: false,
      keyToGroupBy: "guest_id",
    },
  ],
  device: [
    "devices",
    {
      keyField: ["device_id", "listing_id"],
      multipleKeys: true,
      keyToGroupBy: "device_id",
    },
  ],
  template: ["templates", "template_id"],
  action: "action",
};

export const operators = {
  is: {symbol: "==", label: "is"},
  contains: {symbol: "in", label: "contains"},
  not_contains: {symbol: "nin", label: "does not contain"},
  is_not: {symbol: "!=", label: "is not"},
  is_greater_than: {symbol: ">", label: "is greater than"},
  is_less_than: {symbol: "<", label: "is less than"},
  exists: {symbol: "?", label: "exists"},
  not_exists: {symbol: "!", label: "does not exist"},
  is_one_of: {symbol: "one_of", label: "is one of"},
};

export const satisfaction = {
  unknown: {label: "Unknown", value: null},
  unsatisfied: {label: "Unsatisfied", value: 1},
  somewhat_satisfied: {label: "Somewhat satisfied", value: 2},
  neutral: {label: "Neutral", value: 3},
  satisfied: {label: "Satisfied", value: 4},
  highly_satisfied: {label: "Highly satisfied", value: 5},
};

export const segmentsCRM = {
  pending_actions: {
    segment_id: "pending_actions",
    title: "Guests with pending actions",
    metric: "bookings",
    filters: [{path: "booking_action", operator: "?"}],
  },
  guests_in_house: {
    segment_id: "guests_in_house",
    title: "Guests in-house",
    metric: "bookings",
    filters: [
      {
        path: "booking_status",
        operator: "==",
        value: ["confirmed", "checked_in"],
      },
      {path: "checkin_date", operator: "<", value: now},
      {path: "checkout_date", operator: ">", value: now},
    ],
  },
  checking_in_today: {
    segment_id: "checking_in_today",
    title: "Guests checking in today",
    metric: "bookings",
    filters: [
      {path: "booking_status", operator: "==", value: "confirmed"},
      {path: "checkin_date", operator: ">", value: startDay},
      {path: "checkin_date", operator: "<", value: endDay},
    ],
  },
  recently_checked_out: {
    segment_id: "recently_checked_out",
    title: "Recently checked out guests",
    metric: "bookings",
    filters: [
      {path: "checkout_date", operator: "<", value: now},
      {path: "checkout_date", operator: ">", value: now - 7 * 24 * 3600 * 1000},
    ],
  },
};

export const specialFilters = {
  pending_actions: {
    name: "Guests with pending actions",
    type: "value",
    filters: [{path: "booking_action", operator: "?"}],
  },
  checking_in_today: {
    name: "Checking-In Today",
    type: "value",
    filters: [
      {
        path: "booking_status",
        operator: "==",
        value: ["confirmed", "checked_in"],
      },
      {path: "checkin_date", value: now},
    ],
  },
  checking_out_today: {
    name: "Checking-Out Today",
    type: "value",
    filters: [
      {
        path: "booking_status",
        operator: "==",
        value: ["confirmed", "checked_out", "checked_in"],
      },
      {path: "checkout_date", value: now},
    ],
  },
  checked_in: {
    name: "Guests in-house",
    type: "value",
    filters: [
      {
        path: "booking_status",
        operator: "==",
        value: ["confirmed", "checked_in"],
      },
      {path: "checkin_date", operator: "<", value: now},
      {path: "checkout_date", operator: ">", value: now},
    ],
  },
  unverified: {
    name: "Unverified Guests",
    type: "value",
    filters: [{path: "booking_tags", operator: "!=", value: "Verified"}],
  },
  listing_errors: {
    name: "Errors",
    type: "value",
    filters: [{path: "listing_errors", operator: "?"}],
  },
  ungrouped: {
    name: "Ungrouped listings",
    type: "value",
    filters: [{path: "listing_group_id", value: null}],
  },
};

export const guestFilters = {
  preferredFilters: [
    "pending_actions",
    "checking_in_today",
    "checking_out_today",
    "checked_in",
    "unverified",
  ],
  filterKeys: [
    "rating",
    "message_topics",
    "guest_purchased_product_names",
    "enso_total_revenue",
    "guest_purchased_product_types",
    "total_rev",
    "checkin_date",
    "checkout_date",
    "guest_listing",
    "guest_group_id",
    "guest_tags",
    "booking_channel",
    "booking_status",
    "assigned_to",
    "guest_inquiry",
    "booking_tags",
  ],
};
export const rangeFilters = {
  num_listings: {
    values: ["1", "2", "3", "4", "5", "Above 5"],
    ranges: [
      {equal: 1},
      {equal: 2},
      {equal: 3},
      {equal: 4},
      {equal: 5},
      {above: 5},
    ],
  },
  rating: {
    values: [
      "Unknown",
      "Unsatisfied",
      "Somewhat satisfied",
      "Neutral",
      "Satisfied",
      "Highly satisfied",
    ],
    ranges: [
      {equal: null},
      {below: 1.5},
      {above: 1.4, below: 2.5},
      {above: 2.4, below: 3.5},
      {above: 3.4, below: 4.5},
      {above: 4.4},
    ],
  },
  guest_bookings: {
    values: ["1", "2", "3", "Above 3"],
    ranges: [{equal: 1}, {equal: 2}, {equal: 3}, {above: 3}],
  },
  total_rev: {
    values: [
      "$0",
      "$1 - $500",
      "$501 - $1,000",
      "$1,001 - $3,000",
      "Above $3,000",
    ],
    ranges: [
      {equal: 0},
      {above: 0, below: 501},
      {above: 500, below: 1001},
      {above: 1000, below: 3001},
      {above: 3000},
    ],
  },
  enso_total_revenue: {
    values: ["$0", "$1 - $25", "$25 - $50", "$50 - $100", "Above $100"],
    ranges: [
      {equal: 0},
      {above: 0, below: 26},
      {above: 25, below: 51},
      {above: 50, below: 101},
      {above: 100},
    ],
  },
  total_guest_paid: {
    values: [
      "$0",
      "$1 - $500",
      "$501 - $1,000",
      "$1,001 - $3,000",
      "Above $3,000",
    ],
    ranges: [
      {equal: 0},
      {above: 0, below: 501},
      {above: 500, below: 1001},
      {above: 1000, below: 3001},
      {above: 3000},
    ],
  },
  booking_payout: {
    values: [
      "$0",
      "$1 - $50",
      "$51 - $100",
      "$101 - $500",
      "$501 - $1,000",
      "Above $1,000",
    ],
    ranges: [
      {equal: 0},
      {above: 0, below: 51},
      {above: 50, below: 101},
      {above: 100, below: 501},
      {above: 500, below: 1001},
      {above: 1000},
    ],
  },
  guest_inquiry: {
    values: ["Above 0", "1", "2", "3", "4", "5", "Above 5"],
    ranges: [
      {above: 0},
      {equal: 1},
      {equal: 2},
      {equal: 3},
      {equal: 4},
      {equal: 5},
      {above: 5},
    ],
  },
  response_time: {
    values: [
      "One minute or less",
      "Less than half an hour",
      "Less than an hour",
      "Less than a day",
      "More than a day",
    ],
    ranges: [
      {below: 61},
      {below: 1801},
      {below: 3601},
      {below: 86401},
      {above: 86400},
    ], // seconds
  },
  total_people_booked: {
    values: ["1", "2", "3", "4", "5", "Above 5"],
    ranges: [
      {equal: 1},
      {equal: 2},
      {equal: 3},
      {equal: 4},
      {equal: 5},
      {above: 5},
    ],
  },
};

export const CTAsConfig = {
  header: "Monetize your guest experience in a few simple steps",
  steps: [
    {
      key: "brand",
      icon: "briefcase",
      header: "Tell us about your brand",
      text: "Make Boarding Pass match your business by changing your branding colours and uploading a logo.",
    },
    {
      key: "messages",
      icon: "messages",
      header: "Set up your unified inbox",
      text: "Learn how to message your guests via Email, Whatsapp, SMS & Airbnb message.",
    },
    {
      key: "smart_devices",
      icon: "lock",
      disabled: true,
      header: "Set up your smart devices",
      text: "Let's get you connected!",
    },
    {
      key: "guest_journey",
      icon: "list",
      header: {
        noGroups: "Set up your first guest journey",
        noLiveGroups: "Finish setting up your guest journey",
        completed: "Set up another guest journey",
      },
      text: "Enable automated messages, verify your guests, streamline checkin-instructions, collect fees, monetize with upsells & more!",
    },
    {
      key: "team",
      icon: "users",
      header: "Invite your team",
      text: "Add users to the Enso Connect platform to ensure everyone on your team is able to manage guests with ease.",
    },
    {
      key: "boarding_pass",
      icon: "tickets",
      header: "Managing your guest journey",
      text: "Manage how your guest first interacts with their Boarding Pass by managing your Verification Settings.",
    },
    {
      key: "fees",
      icon: "currency",
      disabled: true,
      header: "Manage your fees",
      text: "Be sure to collect any and all mandatory fees from your guests by creating a custom or pre-made fee.",
    },
    {
      key: "upsells",
      icon: "bag",
      disabled: true,
      header: "Manage your upsells",
      text: "Offer your guests the ability to enhance their stay with optional purchases such as an early check-in or a late check-out.",
    },
    {
      key: "automated_messages",
      icon: "message",
      header: "Managing your automessages",
      text: "Customize the guest experience by tailoring your messaging to each type of guest.",
    },
  ],
};

export const collectFieldTypes = {
  text: {
    name: "Text field",
    type: collectFieldTypeEnum.text,
    defaultValue: "Custom field",
  },
  email: {
    name: "Email field",
    type: collectFieldTypeEnum.text,
    defaultValue: "Custom email",
  },
  phone: {
    name: "Phone field",
    type: collectFieldTypeEnum.text,
    defaultValue: "Custom phone",
  },
  address: {
    name: "Address field",
    type: collectFieldTypeEnum.text,
    defaultValue: "Custom address",
  },
  country: {
    name: "Country field",
    type: collectFieldTypeEnum.country,
    defaultValue: "Country",
  },
  number: {
    name: "Number field",
    type: collectFieldTypeEnum.number,
    defaultValue: "Number of",
  },
  date: {
    name: "Date field",
    type: collectFieldTypeEnum.date,
    defaultValue: "Date of",
  },
  time: {
    name: "Time field",
    type: collectFieldTypeEnum.time,
    defaultValue: "Time of",
  },
  single_select: {
    name: "Single select field",
    type: collectFieldTypeEnum.single_select,
    defaultValue: "Single select",
  },
  multi_select: {
    name: "Multi select field",
    type: collectFieldTypeEnum.multi_select,
    defaultValue: "Multi select",
  },
  image: {
    name: "Image upload",
    type: collectFieldTypeEnum.image,
    defaultValue: "Custom image",
  },
};

export const bpFlowColors = {
  "Boarding Pass Opened": "#8B4FEE",
  "Manual Verification": "#EE924F",
  "Automatic Verification": "#7CA8DD",
  Verified: "#5CA6FD",
  "Bypass Checkin Restrictions": "#15326F",
  "Checked-In Through Boarding Pass": "#59D398",
  Revoked: "#FD5C63",
};

export const guestTypes = ["guest", "owner", "maintenance", "cleaner"];
export const inboxesWithNoCount = ["all", "archived"];

// FORMAT
export const BOARDING_PASS_FIELD_TYPES = {
  guest_first_name: "text",
  guest_language: "text",
  guest_last_name: "text",
  guest_email: "email",
  guest_phone: "phone",
  guest_dob: "date",
  guest_address: "address",
  num_pets: "number",
  num_adult: "number",
  num_child: "number",
  guest_travel_reason: "text",
  checkin_time: "time",
  checkout_time: "time",
};

export const GJE_RESOURCE_PATHS = {
  fee: "sections.cnf.cards.fees.data",
  upsell: "sections.pci.cards.upsells.data",
  checkin_step: "sections.ci.cards.checkin_steps.data",
  checkout_step: "sections.co.cards.checkout_steps.data",
  guidebook: "sections.cu.cards.guidebooks.data",
  keycard: "sections.cnf.cards.boarding_pass.data",
  keycard_labels: "sections.cnf.cards.boarding_pass.description",
  experience: [
    "sections.ci.cards.experiences.data",
    "sections.cnf.cards.experiences.data",
    "sections.co.cards.experiences.data",
    "sections.cu.cards.experiences.data",
    "sections.pci.cards.experiences.data",
    "sections.ps.cards.experiences.data",
  ],
};

export const EXISTING_RESOURCE_CONFIG = {
  fee: {
    title: "properties.name",
    description: "properties.description",
  },
  upsell: {
    title: "properties.name",
    description: "properties.description",
  },
  checkin_step: {
    title: "index",
    description: "properties.description",
  },
  checkout_step: {
    title: "index",
    description: "properties.description",
  },
  guidebook: {
    title: "properties.main_page.name",
    description: "properties.preview_text",
  },
  experience: {
    title: "name",
    description: "actions.0.actions",
  },
};

export const whatsapp_templates = {
  welcome:
    "Hi <guest_name>, thank you for booking <listing_name>. Please let me know if you have any questions",
  checkin:
    "Hi my name is <assigned_manager_name>, I will be your point of contact for your stay, so please let me know if you have any questions.",
  checkup:
    "Hi <guest_name>, I hope your stay is going well. Please let me know if you have any questions.",
  checkout:
    "Hi <guest_name>. Thank you for your stay! If you enjoyed yourself, be sure to leave us a review.",
};

export const policyEnums = {
  internet: {
    kindOfInternet: ["wifi", "wired"],
    availableInternet: ["all_areas", "business_center", "some_rooms"],
  },
  parking: {
    locatedParking: ["on_site", "nearby"],
    timeCostParking: ["per_hour", "per_week", "per_stay", "per_day"],
    necessaryReservationParking: [
      "no_reservation_needed",
      "not_possible",
      "reservation_needed",
    ],
  },
  pets: {
    allowedPets: ["allowed", "allowed_on_request"],
  },
};

export const roomTypes = {
  bedroom: "Bedroom",
  bathroom: "Bathroom",
  living_room: "Living Room",
  other: "Other",
};

export const scopes = {
  accounts: {label: "Accounts"},
  reports: {label: "Reports", path: "dashboard"},
  listings: {label: "Listings", path: "listings"},
  messaging: {label: "Messages", path: "messages"},
  crm: {label: "CRM", path: "guests"},
  smart_devices: {label: "Smart Devices"},
  business_settings: {label: "Business Settings", path: "settings"},
  billing: {label: "Billing", path: "settings/billing"},
};

export const userTypes = {
  admin: {
    displayName: "Admin",
    description:
      "Grant full access to the platform, including billing & user management.",
    icon: `<svg width="41" height="25" viewBox="0 0 41 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.2285 24.0871H26.5039C28.125 24.0871 28.8964 23.5989 28.8964 22.5246C28.8964 19.966 25.664 16.2649 20.3711 16.2649C15.0684 16.2649 11.8359 19.966 11.8359 22.5246C11.8359 23.5989 12.6074 24.0871 14.2285 24.0871ZM13.7695 22.6125C13.5156 22.6125 13.4082 22.5442 13.4082 22.3391C13.4082 20.7278 15.8887 17.7395 20.3711 17.7395C24.8437 17.7395 27.3242 20.7278 27.3242 22.3391C27.3242 22.5442 27.2265 22.6125 26.9726 22.6125H13.7695ZM20.3711 15.0442C22.6953 15.0442 24.5898 12.9836 24.5898 10.4641C24.5898 9.0534 23.9897 7.81371 23.0473 7.00123C22.3197 6.37387 21.388 6.88126 20.3711 6.88126C19.2817 6.88126 18.2831 6.44479 17.5312 7.17304C16.6858 7.99193 16.1523 9.17076 16.1523 10.4836C16.1523 12.9934 18.0469 15.0442 20.3711 15.0442ZM20.3711 13.5696C18.9453 13.5696 17.7246 12.2122 17.7246 10.4836C17.7246 8.78443 18.9258 7.47584 20.3711 7.47584C21.8262 7.47584 23.0175 8.75514 23.0175 10.4641C23.0175 12.1926 21.8066 13.5696 20.3711 13.5696Z" fill="#6D7175"/>
        <path d="M16.7818 6.54395L16.9045 7.03476C17.0599 7.67278 17.3993 8 18.0742 8H22.4791C23.158 8 23.4934 7.68095 23.6529 7.03476L23.7756 6.54395H16.7818ZM16.6468 5.98362H23.9147L24.6836 2.83435L24.3482 2.64212L22.4627 4.01635C22.3237 4.11451 22.2296 4.0777 22.1519 3.96727L20.3769 1.28425L20.1805 1.27607L18.3891 3.97954C18.3196 4.08588 18.2378 4.1186 18.0987 4.02044L16.2501 2.67075L15.8574 2.773L16.6468 5.98362ZM16.0088 3.65234C16.5486 3.65234 16.9822 3.21472 16.9822 2.67075C16.9822 2.13905 16.5486 1.69734 16.0088 1.69734C15.4689 1.69734 15.0312 2.13497 15.0312 2.67075C15.0312 3.21472 15.473 3.65234 16.0088 3.65234ZM20.2787 1.95091C20.8145 1.95091 21.2521 1.51329 21.2521 0.973414C21.2521 0.441718 20.8145 0 20.2787 0C19.7347 0 19.3012 0.437626 19.3012 0.973414C19.3012 1.51329 19.7388 1.95091 20.2787 1.95091ZM24.5445 3.65234C25.0803 3.65234 25.522 3.21472 25.522 2.67075C25.522 2.13497 25.0844 1.69734 24.5445 1.69734C24.0087 1.69734 23.5711 2.13905 23.5711 2.67075C23.5711 3.21472 24.0087 3.65234 24.5445 3.65234Z" fill="#6D7175"/>
        </svg>
        `,
    scopes: {
      accounts: "write",
      reports: "write",
      listings: "write",
      messaging: "write",
      crm: "write",
      smart_devices: "write",
      billing: "write",
    },
  },
  team: {
    displayName: "Team",
    description:
      "Grant full access to the platform, excluding billing & user management.",
    icon: `<svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38.6749 19.4121C38.6749 20.5059 38.0108 21.043 36.6827 21.043H29.4328C29.7143 20.6308 29.8562 20.1392 29.8709 19.5977H36.9268C37.1319 19.5977 37.2198 19.5196 37.2198 19.3242C37.2198 16.9024 34.4561 14.6465 31.2628 14.6465C30.1365 14.6465 29.0636 14.9271 28.1499 15.4008C27.8395 15.0262 27.479 14.6693 27.0742 14.3379C28.2638 13.6287 29.7063 13.2012 31.2628 13.2012C35.3546 13.2012 38.6749 16.1699 38.6749 19.4121ZM34.9249 8.06445C34.9249 10.2812 33.2843 12.0879 31.2628 12.0879C29.2608 12.0879 27.6007 10.291 27.6007 8.08398C27.6007 5.92578 29.2608 4.14844 31.2628 4.14844C33.294 4.14844 34.9249 5.89648 34.9249 8.06445ZM29.0557 8.08398C29.0557 9.49023 30.0714 10.6328 31.2628 10.6328C32.4639 10.6328 33.4796 9.49023 33.4796 8.06445C33.4796 6.6875 32.4932 5.60351 31.2628 5.60351C30.0616 5.60351 29.0557 6.70703 29.0557 8.08398Z" fill="#6D7175"/>
        <path d="M12.9378 14.339C12.534 14.67 12.1742 15.0264 11.8643 15.4006C10.9508 14.9271 9.8781 14.6465 8.75195 14.6465C5.55859 14.6465 2.79492 16.9024 2.79492 19.3242C2.79492 19.5196 2.88281 19.5977 3.08789 19.5977H10.1438C10.1586 20.1392 10.3004 20.6308 10.5815 21.043H3.32226C2.00391 21.043 1.33984 20.5059 1.33984 19.4121C1.33984 16.1699 4.66015 13.2012 8.75195 13.2012C10.3054 13.2012 11.7476 13.6291 12.9378 14.339ZM12.4238 8.06445C12.4238 10.2812 10.7734 12.0879 8.76172 12.0879C6.75 12.0879 5.09961 10.291 5.09961 8.08398C5.09961 5.92578 6.75 4.14844 8.76172 4.14844C10.793 4.14844 12.4238 5.89648 12.4238 8.06445ZM6.55468 8.08398C6.55468 9.49023 7.56054 10.6328 8.76172 10.6328C9.96289 10.6328 10.9785 9.49023 10.9785 8.06445C10.9785 6.6875 9.99218 5.60351 8.76172 5.60351C7.55078 5.60351 6.55468 6.70703 6.55468 8.08398Z" fill="#6D7175"/>
        <path d="M20.0118 12C22.336 12 24.2305 9.93945 24.2305 7.41992C24.2305 4.91992 22.3458 2.95703 20.0118 2.95703C17.6876 2.95703 15.793 4.95898 15.793 7.43945C15.793 9.94922 17.6876 12 20.0118 12ZM20.0118 10.5254C18.586 10.5254 17.3653 9.16797 17.3653 7.43945C17.3653 5.74023 18.5567 4.43164 20.0118 4.43164C21.4669 4.43164 22.6583 5.71094 22.6583 7.41992C22.6583 9.14844 21.4473 10.5254 20.0118 10.5254ZM13.8692 21.043H26.1348C27.7657 21.043 28.5372 20.5547 28.5372 19.4805C28.5372 16.9219 25.3047 13.2207 20.002 13.2207C14.709 13.2207 11.4766 16.9219 11.4766 19.4805C11.4766 20.5547 12.2481 21.043 13.8692 21.043ZM13.4004 19.5684C13.1465 19.5684 13.0489 19.5 13.0489 19.2949C13.0489 17.6836 15.5294 14.6953 20.002 14.6953C24.4844 14.6953 26.9649 17.6836 26.9649 19.2949C26.9649 19.5 26.8575 19.5684 26.6036 19.5684H13.4004Z" fill="#6D7175"/>
        </svg>
        `,
    scopes: {
      accounts: "write",
      reports: "write",
      listings: "write",
      messaging: "write",
      crm: "write",
      smart_devices: "write",
      billing: "hide",
    },
  },
  virtualAssistant: {
    displayName: "Virtual Assistant",
    description: "Grant access to messaging for your external team.",
    icon: `<svg width="41" height="24" viewBox="0 0 41 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7051 21.0429H23.9805C25.6016 21.0429 26.373 20.5547 26.373 19.4804C26.373 16.9218 23.1406 13.2207 17.8477 13.2207C12.5449 13.2207 9.3125 16.9218 9.3125 19.4804C9.3125 20.5547 10.084 21.0429 11.7051 21.0429ZM11.2461 19.5683C10.9922 19.5683 10.8848 19.5 10.8848 19.2949C10.8848 17.6836 13.3652 14.6953 17.8477 14.6953C22.3203 14.6953 24.8008 17.6836 24.8008 19.2949C24.8008 19.5 24.7031 19.5683 24.4492 19.5683H11.2461ZM17.8477 12C20.1719 12 22.0664 9.93945 22.0664 7.41992C22.0664 4.91992 20.1816 2.95703 17.8477 2.95703C15.5332 2.95703 13.6289 4.95898 13.6289 7.43945C13.6289 9.94922 15.5234 12 17.8477 12ZM17.8477 10.5254C16.4219 10.5254 15.2012 9.16797 15.2012 7.43945C15.2012 5.74023 16.4023 4.43164 17.8477 4.43164C19.3027 4.43164 20.4941 5.71094 20.4941 7.41992C20.4941 9.14844 19.2832 10.5254 17.8477 10.5254Z" fill="#6D7175"/>
        <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M22.1152 4.26331C22.2015 4.39183 22.2826 4.52443 22.3583 4.66077C22.4351 4.79929 22.5063 4.94168 22.5715 5.08757C22.8638 5.74179 23.036 6.46653 23.0607 7.22958C23.0674 7.23415 23.0741 7.23875 23.0809 7.24337C23.2665 7.37001 23.4787 7.51485 23.7612 7.51485C23.9864 7.51485 24.0956 7.37156 24.1092 7.16686C24.1229 7.07815 24.1638 7.03721 24.2457 7.03721C24.6824 7.03721 25.1669 7.5285 25.1669 7.82873C25.1669 8.11532 25.0577 8.33368 24.8803 8.33368C24.757 8.33368 24.56 8.27539 24.3243 8.20561C23.9728 8.10158 23.535 7.97203 23.1266 7.97203C23.0969 7.97203 23.0673 7.97244 23.0378 7.97325C22.8922 9.52137 22.1429 10.919 21.022 11.8452C21.3134 12.0343 21.6907 12.1344 22.1441 12.1344C22.8469 12.1344 23.3655 12.612 23.3655 13.2603C23.3655 13.3247 23.365 13.3922 23.3646 13.4619C23.3641 13.5254 23.3637 13.5909 23.3636 13.6578C23.8651 13.9503 24.3245 14.277 24.7389 14.6281C25.098 14.9323 25.4275 15.2589 25.7227 15.6011C26.4351 15.0548 26.9953 14.1085 27.2372 13.7C27.2595 13.6624 27.2791 13.6292 27.2958 13.6014C27.5672 13.1651 27.5273 12.7287 27.4966 12.3927C27.488 12.2978 27.48 12.211 27.48 12.1344C27.48 12.0382 27.5909 11.9002 27.7258 11.7323C27.9355 11.4712 28.2033 11.1377 28.2033 10.7765C28.2033 10.4341 27.7485 10.1317 27.3576 9.87167C27.0629 9.67569 26.8045 9.50384 26.8045 9.3572C26.8045 9.13885 26.9683 8.94779 27.1457 8.94779C27.2836 8.94779 27.5136 9.14784 27.7623 9.36419C28.0552 9.61893 28.374 9.89627 28.5991 9.89627C28.7558 9.89627 28.8293 9.81754 28.8919 9.75049C28.9383 9.70075 28.9787 9.65744 29.0427 9.65744C29.175 9.65744 29.2649 9.94066 29.3844 10.3172C29.5591 10.8676 29.7971 11.6174 30.3234 11.9735C29.9105 14.0707 28.3868 15.8018 26.4054 16.5139C26.5777 16.7831 26.7292 17.0576 26.858 17.3349C29.4755 16.3284 31.3626 13.7717 31.3626 10.8311C31.3626 7.02356 28.2033 3.87109 24.3958 3.87109C23.5995 3.87109 22.8316 4.00949 22.1152 4.26331ZM26.1002 6.78485C26.1874 6.75131 26.2779 6.71651 26.4087 6.71651C26.4708 6.71651 26.5303 6.74338 26.5978 6.77385C26.6861 6.81374 26.7881 6.85979 26.9273 6.85979C27.0775 6.85979 27.1935 6.71651 27.1935 6.53909C27.1935 6.21839 26.8318 5.97274 26.3542 5.97274C25.7946 5.97274 25.4671 6.15697 25.4671 6.4845C25.4671 6.69603 25.6241 6.84615 25.8356 6.84615C25.9408 6.84615 26.0191 6.81604 26.1002 6.78485Z" fill="#6D7175"/>
        </svg>
        `,
    scopes: {
      accounts: "read",
      reports: "read",
      listings: "read",
      messaging: "write",
      crm: "read",
      smart_devices: "hide",
      billing: "hide",
    },
  },
  cohost: {
    displayName: "Co-Host",
    description:
      "Invite one of your hosts and give them read-only access to a subset of your properties.",
    icon: `<svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.8691 21.0429H26.1446C27.7657 21.0429 28.5371 20.5547 28.5371 19.4804C28.5371 16.9218 25.3047 13.2207 20.0117 13.2207C14.709 13.2207 11.4766 16.9218 11.4766 19.4804C11.4766 20.5547 12.248 21.0429 13.8691 21.0429ZM13.4102 19.5683C13.1563 19.5683 13.0488 19.5 13.0488 19.2949C13.0488 17.6836 15.5293 14.6953 20.0117 14.6953C24.4844 14.6953 26.9649 17.6836 26.9649 19.2949C26.9649 19.5 26.8672 19.5683 26.6133 19.5683H13.4102ZM20.0117 12C22.336 12 24.2305 9.93945 24.2305 7.41992C24.2305 4.91992 22.3457 2.95703 20.0117 2.95703C17.6973 2.95703 15.793 4.95898 15.793 7.43945C15.793 9.94922 17.6875 12 20.0117 12ZM20.0117 10.5254C18.5859 10.5254 17.3652 9.16797 17.3652 7.43945C17.3652 5.74023 18.5664 4.43164 20.0117 4.43164C21.4668 4.43164 22.6582 5.71094 22.6582 7.41992C22.6582 9.14844 21.4473 10.5254 20.0117 10.5254Z" fill="#6D7175"/>
        </svg>
        `,
    scopes: {
      accounts: "read",
      reports: "read",
      listings: "read",
      messaging: "read",
      crm: "read",
      smart_devices: "hide",
      billing: "hide",
    },
  },
};

export const bookingStatusLabels = {};
// Removing deprecated enum elements that start with "_"
const bkgStatusValues = Object.values(
  Object.keys(bookingStatusEnum)
    .filter((el) => !el.startsWith("_"))
    .reduce((r, k) => ((r[k] = bookingStatusEnum[k]), r), {}),
);
_.each(bkgStatusValues, (element) => {
  const formattedEl = capitalize(element, "_");
  bookingStatusLabels[element] = formattedEl;
});

export const bookingTagsLabels = {};
const bkgTagValues = Object.values(BookingTagEnum);
_.each(bkgTagValues, (element) => {
  const formattedEl = capitalize(element, "_");
  bookingTagsLabels[element] = formattedEl;
});
bookingTagsLabels["unverified"] = ["Not Verified"];

export const guestTagsLabels = {};
const guestTagsValues = Object.values(guestTagEnum);
_.each(guestTagsValues, (element) => {
  const formattedEl = capitalize(element, "_");
  guestTagsLabels[element] = formattedEl;
});

export const guestStageLabels = {};
const guestStageValues = Object.values(guestStage);
_.each(guestStageValues, (element) => {
  const formattedEl = capitalize(element, "_").split(" ").join("-");
  guestStageLabels[element] = formattedEl;
});

export const messageSenderLabels = {
  user: "User",
  other_user: "Guest",
  automessage: "Automessage",
  chatbot: "Chatbot",
};

export const guestIntegrationLabels = {
  vrbo: "VRBO",
  ab: "Airbnb",
};

export const bucketMap = {
  buckets: [
    "Airbnb",
    "VRBO",
    "Expedia",
    "Abritel",
    "Agoda",
    "Atraveo",
    "Best Fewo",
    "Booking.com",
    "Casamundo",
    "E-Domizil",
    "Flipkey",
    "Google",
    "Holiday Lettings",
    "Happy Stay",
    "Rentals United",
    "Home Away",
    "Veepee",
    "Simplissimmo",
    "Hotel Tonight",
    "Facebook Messenger",
    "NineFlats",
    "Trip Advisor",
    "Direct Booking",
    "other",
  ],
  bucket_metadata: {
    Airbnb: {
      label: "Airbnb",
      color: "#FF585B",
    },
    VRBO: {
      label: "VRBO",
      color: "#0D568C",
    },
    Expedia: {
      label: "Expedia",
      color: "#0D128C",
    },
    Abritel: {
      label: "Abritel",
      color: "#0D428C",
    },
    Agoda: {
      label: "Agoda",
      color: "#0D428F",
    },
    Atraveo: {
      label: "Atraveo",
      color: "#1D428C",
    },
    "Best Fewo": {
      label: "Best Fewo",
      color: "#0E248C",
    },
    "Booking.com": {
      label: "Booking.com",
      color: "#0D921C",
    },
    Casamundo: {
      label: "Casamundo",
      color: "#0D907C",
    },
    "E-Domizil": {
      label: "E-Domizil",
      color: "#0D428E",
    },
    Flipkey: {
      label: "Flipkey",
      color: "#0D478E",
    },
    Google: {
      label: "Google",
      color: "#0D408E",
    },
    "Happy Stay": {
      label: "Happy Stay",
      color: "#0D228E",
    },
    "Direct Booking": {
      label: "Direct Booking",
      color: "#0D118E",
    },
    "Holiday Lettings": {
      label: "Holiday Lettings",
      color: "#2D428E",
    },
  },
};

export const bookingChannelLabels = {};
_.each(bucketMap.buckets, (element) => {
  bookingChannelLabels[element] = element;
});

export const messageChannelLabels = {
  SMS: "SMS",
  email: "Email",
  airbnb: "Airbnb",
  whatsapp: "Whatsapp",
  automessage: "Automessage",
  ota_email: "OTA Message",
};

export const notificationTypeLabels = {
  new_booking: "New Booking",
  upd_booking: "Booking Update",
  new_inquiry: "New Inquiry",
  // # guest
  new_guest: "New Guest",
  upd_guest: "Guest Update",
  // # listing
  new_listing: "New Listing",
  // # message
  new_message: "New Message",
  // # device
  device_event: "Device Event",
  new_device: "New Device",
  // # experience
  exp_triggered: "Experience Triggered",
  exp_validation: "Experience Validation",
};

export const questionTypeLabels = {};

export const serviceLabels = {};
const serviceValues = Object.entries(serviceEnum);
_.each(serviceValues, (el) => {
  const formattedLabel = capitalize(el[0], "_");
  serviceLabels[el[1]] = formattedLabel;
});

export const deviceTriggerLabels = {
  noise_loud: "detects a loud noise",
  second_noise_loud: "detects a second loud noise",
  third_noise_loud: "detects a third loud noise",
  noise_quiet: "detects that noise has quieted",
  door_unlocked: "unlocks the door",
  door_locked: "locks the door",
  device_disconnected: "is disconnected",
  device_connected: "is connected",
  lock_error: "has a lock error",
  recovery_code_viewed: "has had an access code viewed",
  no_available_codes: "has no available codes",
  low_battery: "is low battery",
};

export const supportedNotificationTypes = [
  "upd_booking",
  "message_error",
  "new_device",
  "bkg_cfrmd",
  "bkg_cncld",
  "bkg_pndg",
  "inq",
  "derr",
  "device_event",
  "kcc",
  "kc_bypass",
  "man_ver",
  "ver",
  "re_ver",
  "deny_ver",
  "need_bp_ver",
  "call",
  "pr_err",
  "pr_action",
  "pr_pndg",
  "pr_cfmrd",
  "pr_cncld",
  "pr_prch",
  "pr_refd",
  "dep_clct",
  "ver_err",
];

export const allTriggers = {};
const triggerTypesKeys = Object.keys(triggerParams);
_.each(triggerTypesKeys, (tk) => {
  _.each(triggerParams[tk], (trigger) => {
    allTriggers[trigger.trigger] = {...trigger, type: tk};
  });
});

export const triggerConfig = {};
export const serviceActions = {};

const actionsArr = Object.keys(actionParams);
const triggerKeys = Object.keys(allTriggers);
for (let i = 0; i < actionsArr.length; i++) {
  const key = actionsArr[i];
  const item = actionParams[key];
  let triggers = item.triggers ?? [];
  triggers = triggers.map((t) => t.trigger);

  if (!!serviceActions[item.service_account]) {
    serviceActions[item.service_account].push(key);
  } else {
    serviceActions[item.service_account] = [key];
  }

  if (!triggers.length) {
    for (let ind = 0; ind < triggerKeys.length; ind++) {
      const tk = triggerKeys[ind];
      if (!triggerConfig[tk]) {
        triggerConfig[tk] = {
          actions: [],
          services: [],
        };
      }
      let newActions = new Set(triggerConfig[tk].actions.concat(key));
      let newServices = new Set(
        triggerConfig[tk].services.concat(item.service_account),
      );
      triggerConfig[tk].actions = [...newActions];
      triggerConfig[tk].services = [...newServices];
    }
  } else {
    for (let ind = 0; ind < triggers.length; ind++) {
      const t = triggers[ind];
      if (!triggerConfig[t]) {
        triggerConfig[t] = {
          actions: [],
          services: [],
        };
      }
      let newActions = new Set(triggerConfig[t].actions.concat(key));
      let newServices = new Set(
        triggerConfig[t].services.concat(item.service_account),
      );
      triggerConfig[t].actions = [...newActions];
      triggerConfig[t].services = [...newServices];
    }
  }
}

export const conditionTypeLabels = {
  past_triggers: "Previous trigger",
  time: "Time",
  custom: "Custom variable",
};

export const callDestinationLabels = {
  guest_phone: "Guest Phone",
  assigned_manager: "Assigned Manager",
  "specific number": "Specific Number",
};

export const callRedirectLabels = {
  assigned_manager: "Assigned Manager",
  "specific number": "Specific Number",
};

export let experienceTypesLabels = {
  msg: "Messaging",
  acc: "Access & Security",
  sns: "Smarthome",
  inq: "Inquiry",
  cnf: "Confirmed Booking",
  pci: "Pre Check-in",
  ci: "Check-in",
  cu: "Check-up",
  co: "Check-out",
  pco: "Pre Check-out",
  ps: "Post Stay",
  mk: "Marketing",
};

// CRM
export const guestListExportTypes = {
  json: "json",
  csv: "csv",
};

export const crmFileContentType = {
  json: "application/json;charset=utf-8",
  csv: "text/csv;charset=utf-8",
};

// INTEGRATION ACCOUNTS
export const integrations = {
  ab: "Airbnb",
  bkp: "BookingPal",
  bks: "BookingSync",
  mews: "Mews",
  vrbo: "VRBO",
  chnl: "Channel Connector",
  gy: "Guesty",
  ha: "Hostaway",
};

// LOCALIZATION
export const countryName = {
  AF: "Afghanistan",
  AX: "\\u00c5land Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, Plurinational State of",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "C\\u00f4te d'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Cura\\u00e7ao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "R\\u00e9union",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barth\\u00e9lemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Bolivarian Republic of",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const countries = [
  {
    name: "Afghanistan",
    code: "AF",
    emoji: "🇦🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/af.svg",
    dialCodes: ["+93"],
    slug: "afghanistan",
  },
  {
    name: "Albania",
    code: "AL",
    emoji: "🇦🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/al.svg",
    dialCodes: ["+355"],
    slug: "albania",
  },
  {
    name: "Andorra",
    code: "AD",
    emoji: "🇦🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ad.svg",
    dialCodes: ["+376"],
    slug: "andorra",
  },
  {
    name: "Angola",
    code: "AO",
    emoji: "🇦🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ao.svg",
    dialCodes: ["+244"],
    slug: "angola",
  },
  {
    name: "Anguilla",
    code: "AI",
    emoji: "🇦🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ai.svg",
    dialCodes: ["+1264"],
    slug: "anguilla",
  },
  {
    name: "Antarctica",
    code: "AQ",
    emoji: "🇦🇶",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/aq.svg",
    dialCodes: ["+672"],
    slug: "antarctica",
  },
  {
    name: "Antigua & Barbuda",
    code: "AG",
    emoji: "🇦🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ag.svg",
    dialCodes: ["+1268"],
    slug: "antigua-and-barbuda",
  },
  {
    name: "Argentina",
    code: "AR",
    emoji: "🇦🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ar.svg",
    dialCodes: ["+54"],
    slug: "argentina",
  },
  {
    name: "Armenia",
    code: "AM",
    emoji: "🇦🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/am.svg",
    dialCodes: ["+374"],
    slug: "armenia",
  },
  {
    name: "Aruba",
    code: "AW",
    emoji: "🇦🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/aw.svg",
    dialCodes: ["+297"],
    slug: "aruba",
  },
  {
    name: "Ascension Island",
    code: "AC",
    emoji: "🇦🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ac.svg",
    slug: "ascension-island",
  },
  {
    name: "Australia",
    code: "AU",
    emoji: "🇦🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/au.svg",
    dialCodes: ["+61"],
    slug: "australia",
  },
  {
    name: "Austria",
    code: "AT",
    emoji: "🇦🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/at.svg",
    dialCodes: ["+43"],
    slug: "austria",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    emoji: "🇦🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/az.svg",
    dialCodes: ["+994"],
    slug: "azerbaijan",
  },
  {
    name: "Bahamas",
    code: "BS",
    emoji: "🇧🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bs.svg",
    dialCodes: ["+1242"],
    slug: "bahamas",
  },
  {
    name: "Bahrain",
    code: "BH",
    emoji: "🇧🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bh.svg",
    dialCodes: ["+973"],
    slug: "bahrain",
  },
  {
    name: "Bangladesh",
    code: "BD",
    emoji: "🇧🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bd.svg",
    dialCodes: ["+880"],
    slug: "bangladesh",
  },
  {
    name: "Barbados",
    code: "BB",
    emoji: "🇧🇧",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bb.svg",
    dialCodes: ["+1246"],
    slug: "barbados",
  },
  {
    name: "Belarus",
    code: "BY",
    emoji: "🇧🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/by.svg",
    dialCodes: ["+375"],
    slug: "belarus",
  },
  {
    name: "Belgium",
    code: "BE",
    emoji: "🇧🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/be.svg",
    dialCodes: ["+32"],
    slug: "belgium",
  },
  {
    name: "Belize",
    code: "BZ",
    emoji: "🇧🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bz.svg",
    dialCodes: ["+501"],
    slug: "belize",
  },
  {
    name: "Benin",
    code: "BJ",
    emoji: "🇧🇯",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bj.svg",
    dialCodes: ["+229"],
    slug: "benin",
  },
  {
    name: "Bermuda",
    code: "BM",
    emoji: "🇧🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bm.svg",
    dialCodes: ["+1441"],
    slug: "bermuda",
  },
  {
    name: "Bhutan",
    code: "BT",
    emoji: "🇧🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bt.svg",
    dialCodes: ["+975"],
    slug: "bhutan",
  },
  {
    name: "Bolivia",
    code: "BO",
    emoji: "🇧🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bo.svg",
    dialCodes: ["+591"],
    slug: "bolivia",
  },
  {
    name: "Bosnia & Herzegovina",
    code: "BA",
    emoji: "🇧🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ba.svg",
    dialCodes: ["+387"],
    slug: "bosnia-and-herzegovina",
  },
  {
    name: "Botswana",
    code: "BW",
    emoji: "🇧🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bw.svg",
    dialCodes: ["+267"],
    slug: "botswana",
  },
  {
    name: "Brazil",
    code: "BR",
    emoji: "🇧🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/br.svg",
    dialCodes: ["+55"],
    slug: "brazil",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    emoji: "🇮🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/io.svg",
    slug: "british-indian-ocean-territory",
  },
  {
    name: "Brunei",
    code: "BN",
    emoji: "🇧🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bn.svg",
    dialCodes: ["+673"],
    slug: "brunei",
  },
  {
    name: "Bulgaria",
    code: "BG",
    emoji: "🇧🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bg.svg",
    dialCodes: ["+359"],
    slug: "bulgaria",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    emoji: "🇧🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bf.svg",
    dialCodes: ["+226"],
    slug: "burkina-faso",
  },
  {
    name: "Burundi",
    code: "BI",
    emoji: "🇧🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bi.svg",
    dialCodes: ["+257"],
    slug: "burundi",
  },
  {
    name: "Cabo Verde",
    code: "CV",
    emoji: "🇨🇻",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cv.svg",
    dialCodes: ["+238"],
    slug: "cabo-verde",
  },
  {
    name: "Cambodia",
    code: "KH",
    emoji: "🇰🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kh.svg",
    dialCodes: ["+855"],
    slug: "cambodia",
  },
  {
    name: "Cameroon",
    code: "CM",
    emoji: "🇨🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cm.svg",
    dialCodes: ["+237"],
    slug: "cameroon",
  },
  {
    name: "Canada",
    code: "CA",
    emoji: "🇨🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ca.svg",
    dialCodes: ["+1"],
    slug: "canada",
  },
  {
    name: "Cayman Islands",
    code: "KY",
    emoji: "🇰🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ky.svg",
    dialCodes: ["+1345"],
    slug: "cayman-islands",
  },
  {
    name: "Central African Republic",
    code: "CF",
    emoji: "🇨🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cf.svg",
    dialCodes: ["+236"],
    slug: "central-african-republic",
  },
  {
    name: "Chad",
    code: "TD",
    emoji: "🇹🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/td.svg",
    dialCodes: ["+235"],
    slug: "chad",
  },
  {
    name: "Chile",
    code: "CL",
    emoji: "🇨🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cl.svg",
    dialCodes: ["+56"],
    slug: "chile",
  },
  {
    name: "China",
    code: "CN",
    emoji: "🇨🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cn.svg",
    dialCodes: ["+86"],
    slug: "china",
  },
  {
    name: "Christmas Island",
    code: "CX",
    emoji: "🇨🇽",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cx.svg",
    slug: "christmas-island",
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    emoji: "🇨🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cc.svg",
    slug: "cocos-(keeling)-islands",
  },
  {
    name: "Colombia",
    code: "CO",
    emoji: "🇨🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/co.svg",
    dialCodes: ["+57"],
    slug: "colombia",
  },
  {
    name: "Comoros",
    code: "KM",
    emoji: "🇰🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/km.svg",
    dialCodes: ["+269"],
    slug: "comoros",
  },
  {
    name: "Congo - Brazzaville",
    code: "CG",
    emoji: "🇨🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cg.svg",
    dialCodes: ["+242"],
    slug: "congo-brazzaville",
  },
  {
    name: "Congo - Kinshasa",
    code: "CD",
    emoji: "🇨🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cd.svg",
    dialCodes: ["+243"],
    slug: "congo-kinshasa",
  },
  {
    name: "Cook Islands",
    code: "CK",
    emoji: "🇨🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ck.svg",
    dialCodes: ["+682"],
    slug: "cook-islands",
  },
  {
    name: "Costa Rica",
    code: "CR",
    emoji: "🇨🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cr.svg",
    dialCodes: ["+506"],
    slug: "costa-rica",
  },
  {
    name: "Croatia",
    code: "HR",
    emoji: "🇭🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/hr.svg",
    dialCodes: ["+385"],
    slug: "croatia",
  },
  {
    name: "Cuba",
    code: "CU",
    emoji: "🇨🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cu.svg",
    dialCodes: ["+53"],
    slug: "cuba",
  },
  {
    name: "Curaçao",
    code: "CW",
    emoji: "🇨🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cw.svg",
    dialCodes: ["+599"],
    slug: "curacao",
  },
  {
    name: "Cyprus",
    code: "CY",
    emoji: "🇨🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cy.svg",
    dialCodes: ["+357"],
    slug: "cyprus",
  },
  {
    name: "Czechia",
    code: "CZ",
    emoji: "🇨🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/cz.svg",
    dialCodes: ["+420"],
    slug: "czechia",
  },
  {
    name: "Côte d'Ivoire",
    code: "CI",
    emoji: "🇨🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ci.svg",
    dialCodes: ["+225"],
    slug: "cote-d'ivoire",
  },
  {
    name: "Denmark",
    code: "DK",
    emoji: "🇩🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/dk.svg",
    dialCodes: ["+45"],
    slug: "denmark",
  },
  {
    name: "Djibouti",
    code: "DJ",
    emoji: "🇩🇯",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/dj.svg",
    dialCodes: ["+253"],
    slug: "djibouti",
  },
  {
    name: "Dominica",
    code: "DM",
    emoji: "🇩🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/dm.svg",
    dialCodes: ["+1767"],
    slug: "dominica",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    emoji: "🇩🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/do.svg",
    dialCodes: ["+1 809", "+1 829", "+1 849"],
    slug: "dominican-republic",
  },
  {
    name: "Ecuador",
    code: "EC",
    emoji: "🇪🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ec.svg",
    dialCodes: ["+593"],
    slug: "ecuador",
  },
  {
    name: "Egypt",
    code: "EG",
    emoji: "🇪🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/eg.svg",
    dialCodes: ["+20"],
    slug: "egypt",
  },
  {
    name: "El Salvador",
    code: "SV",
    emoji: "🇸🇻",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sv.svg",
    dialCodes: ["+503"],
    slug: "el-salvador",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    emoji: "🇬🇶",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gq.svg",
    dialCodes: ["+240"],
    slug: "equatorial-guinea",
  },
  {
    name: "Eritrea",
    code: "ER",
    emoji: "🇪🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/er.svg",
    dialCodes: ["+291"],
    slug: "eritrea",
  },
  {
    name: "Estonia",
    code: "EE",
    emoji: "🇪🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ee.svg",
    dialCodes: ["+372"],
    slug: "estonia",
  },
  {
    name: "Eswatini",
    code: "SZ",
    emoji: "🇸🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sz.svg",
    dialCodes: ["+268"],
    slug: "eswatini",
  },
  {
    name: "Ethiopia",
    code: "ET",
    emoji: "🇪🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/et.svg",
    dialCodes: ["+251"],
    slug: "ethiopia",
  },
  {
    name: "Falkland Islands",
    code: "FK",
    emoji: "🇫🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fk.svg",
    dialCodes: ["+500"],
    slug: "falkland-islands",
  },
  {
    name: "Faroe Islands",
    code: "FO",
    emoji: "🇫🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fo.svg",
    dialCodes: ["+298"],
    slug: "faroe-islands",
  },
  {
    name: "Fiji",
    code: "FJ",
    emoji: "🇫🇯",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fj.svg",
    dialCodes: ["+679"],
    slug: "fiji",
  },
  {
    name: "Finland",
    code: "FI",
    emoji: "🇫🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fi.svg",
    dialCodes: ["+358"],
    slug: "finland",
  },
  {
    name: "France",
    code: "FR",
    emoji: "🇫🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fr.svg",
    dialCodes: ["+33"],
    slug: "france",
  },
  {
    name: "French Guiana",
    code: "GF",
    emoji: "🇬🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gf.svg",
    dialCodes: ["+594"],
    slug: "french-guiana",
  },
  {
    name: "French Polynesia",
    code: "PF",
    emoji: "🇵🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pf.svg",
    dialCodes: ["+689"],
    slug: "french-polynesia",
  },
  {
    name: "French Southern Territories",
    code: "TF",
    emoji: "🇹🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tf.svg",
    slug: "french-southern-territories",
  },
  {
    name: "Gabon",
    code: "GA",
    emoji: "🇬🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ga.svg",
    dialCodes: ["+241"],
    slug: "gabon",
  },
  {
    name: "Gambia",
    code: "GM",
    emoji: "🇬🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gm.svg",
    dialCodes: ["+220"],
    slug: "gambia",
  },
  {
    name: "Georgia",
    code: "GE",
    emoji: "🇬🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ge.svg",
    dialCodes: ["+995"],
    slug: "georgia",
  },
  {
    name: "Germany",
    code: "DE",
    emoji: "🇩🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/de.svg",
    dialCodes: ["+49"],
    slug: "germany",
  },
  {
    name: "Ghana",
    code: "GH",
    emoji: "🇬🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gh.svg",
    dialCodes: ["+233"],
    slug: "ghana",
  },
  {
    name: "Gibraltar",
    code: "GI",
    emoji: "🇬🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gi.svg",
    dialCodes: ["+350"],
    slug: "gibraltar",
  },
  {
    name: "Greece",
    code: "GR",
    emoji: "🇬🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gr.svg",
    dialCodes: ["+30"],
    slug: "greece",
  },
  {
    name: "Greenland",
    code: "GL",
    emoji: "🇬🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gl.svg",
    dialCodes: ["+299"],
    slug: "greenland",
  },
  {
    name: "Grenada",
    code: "GD",
    emoji: "🇬🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gd.svg",
    dialCodes: ["+1473"],
    slug: "grenada",
  },
  {
    name: "Guadeloupe",
    code: "GP",
    emoji: "🇬🇵",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gp.svg",
    dialCodes: ["+590"],
    slug: "guadeloupe",
  },
  {
    name: "Guam",
    code: "GU",
    emoji: "🇬🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gu.svg",
    dialCodes: ["+1671"],
    slug: "guam",
  },
  {
    name: "Guatemala",
    code: "GT",
    emoji: "🇬🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gt.svg",
    dialCodes: ["+502"],
    slug: "guatemala",
  },
  {
    name: "Guernsey",
    code: "GG",
    emoji: "🇬🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gg.svg",
    dialCodes: ["+44"],
    slug: "guernsey",
  },
  {
    name: "Guinea",
    code: "GN",
    emoji: "🇬🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gn.svg",
    dialCodes: ["+224"],
    slug: "guinea",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    emoji: "🇬🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gw.svg",
    dialCodes: ["+245"],
    slug: "guinea-bissau",
  },
  {
    name: "Guyana",
    code: "GY",
    emoji: "🇬🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gy.svg",
    dialCodes: ["+592"],
    slug: "guyana",
  },
  {
    name: "Haiti",
    code: "HT",
    emoji: "🇭🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ht.svg",
    dialCodes: ["+509"],
    slug: "haiti",
  },
  {
    name: "Heard & McDonald Islands",
    code: "HM",
    emoji: "🇭🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/hm.svg",
    slug: "heard-and-mcdonald-islands",
  },
  {
    name: "Honduras",
    code: "HN",
    emoji: "🇭🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/hn.svg",
    dialCodes: ["+504"],
    slug: "honduras",
  },
  {
    name: "Hong Kong SAR China",
    code: "HK",
    emoji: "🇭🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/hk.svg",
    dialCodes: ["+852"],
    slug: "hong-kong-sar-china",
  },
  {
    name: "Hungary",
    code: "HU",
    emoji: "🇭🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/hu.svg",
    dialCodes: ["+36"],
    slug: "hungary",
  },
  {
    name: "Iceland",
    code: "IS",
    emoji: "🇮🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/is.svg",
    dialCodes: ["+354"],
    slug: "iceland",
  },
  {
    name: "India",
    code: "IN",
    emoji: "🇮🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/in.svg",
    dialCodes: ["+91"],
    slug: "india",
  },
  {
    name: "Indonesia",
    code: "ID",
    emoji: "🇮🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/id.svg",
    dialCodes: ["+62"],
    slug: "indonesia",
  },
  {
    name: "Iran",
    code: "IR",
    emoji: "🇮🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ir.svg",
    dialCodes: ["+98"],
    slug: "iran",
  },
  {
    name: "Iraq",
    code: "IQ",
    emoji: "🇮🇶",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/iq.svg",
    dialCodes: ["+964"],
    slug: "iraq",
  },
  {
    name: "Ireland",
    code: "IE",
    emoji: "🇮🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ie.svg",
    dialCodes: ["+353"],
    slug: "ireland",
  },
  {
    name: "Isle of Man",
    code: "IM",
    emoji: "🇮🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/im.svg",
    dialCodes: ["+44"],
    slug: "isle-of-man",
  },
  {
    name: "Israel",
    code: "IL",
    emoji: "🇮🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/il.svg",
    dialCodes: ["+972"],
    slug: "israel",
  },
  {
    name: "Italy",
    code: "IT",
    emoji: "🇮🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/it.svg",
    dialCodes: ["+39"],
    slug: "italy",
  },
  {
    name: "Jamaica",
    code: "JM",
    emoji: "🇯🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/jm.svg",
    dialCodes: ["+1 876"],
    slug: "jamaica",
  },
  {
    name: "Japan",
    code: "JP",
    emoji: "🇯🇵",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/jp.svg",
    dialCodes: ["+81"],
    slug: "japan",
  },
  {
    name: "Jersey",
    code: "JE",
    emoji: "🇯🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/je.svg",
    dialCodes: ["+44"],
    slug: "jersey",
  },
  {
    name: "Jordan",
    code: "JO",
    emoji: "🇯🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/jo.svg",
    dialCodes: ["+962"],
    slug: "jordan",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    emoji: "🇰🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kz.svg",
    dialCodes: ["+7"],
    slug: "kazakhstan",
  },
  {
    name: "Kenya",
    code: "KE",
    emoji: "🇰🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ke.svg",
    dialCodes: ["+254"],
    slug: "kenya",
  },
  {
    name: "Kiribati",
    code: "KI",
    emoji: "🇰🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ki.svg",
    dialCodes: ["+686"],
    slug: "kiribati",
  },
  {
    name: "Kosovo",
    code: "XK",
    emoji: "🇽🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/xk.svg",
    dialCodes: ["+383"],
    slug: "kosovo",
  },
  {
    name: "Kuwait",
    code: "KW",
    emoji: "🇰🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kw.svg",
    dialCodes: ["+965"],
    slug: "kuwait",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    emoji: "🇰🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kg.svg",
    dialCodes: ["+996"],
    slug: "kyrgyzstan",
  },
  {
    name: "Laos",
    code: "LA",
    emoji: "🇱🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/la.svg",
    dialCodes: ["+856"],
    slug: "laos",
  },
  {
    name: "Latvia",
    code: "LV",
    emoji: "🇱🇻",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lv.svg",
    dialCodes: ["+371"],
    slug: "latvia",
  },
  {
    name: "Lebanon",
    code: "LB",
    emoji: "🇱🇧",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lb.svg",
    dialCodes: ["+961"],
    slug: "lebanon",
  },
  {
    name: "Lesotho",
    code: "LS",
    emoji: "🇱🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ls.svg",
    dialCodes: ["+266"],
    slug: "lesotho",
  },
  {
    name: "Liberia",
    code: "LR",
    emoji: "🇱🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lr.svg",
    dialCodes: ["+231"],
    slug: "liberia",
  },
  {
    name: "Libya",
    code: "LY",
    emoji: "🇱🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ly.svg",
    dialCodes: ["+218"],
    slug: "libya",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    emoji: "🇱🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/li.svg",
    dialCodes: ["+423"],
    slug: "liechtenstein",
  },
  {
    name: "Lithuania",
    code: "LT",
    emoji: "🇱🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lt.svg",
    dialCodes: ["+370"],
    slug: "lithuania",
  },
  {
    name: "Luxembourg",
    code: "LU",
    emoji: "🇱🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lu.svg",
    dialCodes: ["+352"],
    slug: "luxembourg",
  },
  {
    name: "Macao SAR China",
    code: "MO",
    emoji: "🇲🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mo.svg",
    dialCodes: ["+853"],
    slug: "macao-sar-china",
  },
  {
    name: "Madagascar",
    code: "MG",
    emoji: "🇲🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mg.svg",
    dialCodes: ["+261"],
    slug: "madagascar",
  },
  {
    name: "Malawi",
    code: "MW",
    emoji: "🇲🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mw.svg",
    dialCodes: ["+265"],
    slug: "malawi",
  },
  {
    name: "Malaysia",
    code: "MY",
    emoji: "🇲🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/my.svg",
    dialCodes: ["+60"],
    slug: "malaysia",
  },
  {
    name: "Maldives",
    code: "MV",
    emoji: "🇲🇻",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mv.svg",
    dialCodes: ["+960"],
    slug: "maldives",
  },
  {
    name: "Mali",
    code: "ML",
    emoji: "🇲🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ml.svg",
    dialCodes: ["+223"],
    slug: "mali",
  },
  {
    name: "Malta",
    code: "MT",
    emoji: "🇲🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mt.svg",
    dialCodes: ["+356"],
    slug: "malta",
  },
  {
    name: "Marshall Islands",
    code: "MH",
    emoji: "🇲🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mh.svg",
    dialCodes: ["+692"],
    slug: "marshall-islands",
  },
  {
    name: "Martinique",
    code: "MQ",
    emoji: "🇲🇶",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mq.svg",
    dialCodes: ["+596"],
    slug: "martinique",
  },
  {
    name: "Mauritania",
    code: "MR",
    emoji: "🇲🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mr.svg",
    dialCodes: ["+222"],
    slug: "mauritania",
  },
  {
    name: "Mauritius",
    code: "MU",
    emoji: "🇲🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mu.svg",
    dialCodes: ["+230"],
    slug: "mauritius",
  },
  {
    name: "Mayotte",
    code: "YT",
    emoji: "🇾🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/yt.svg",
    dialCodes: ["+262"],
    slug: "mayotte",
  },
  {
    name: "Mexico",
    code: "MX",
    emoji: "🇲🇽",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mx.svg",
    dialCodes: ["+52"],
    slug: "mexico",
  },
  {
    name: "Micronesia",
    code: "FM",
    emoji: "🇫🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/fm.svg",
    dialCodes: ["+691"],
    slug: "micronesia",
  },
  {
    name: "Moldova",
    code: "MD",
    emoji: "🇲🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/md.svg",
    dialCodes: ["+373"],
    slug: "moldova",
  },
  {
    name: "Monaco",
    code: "MC",
    emoji: "🇲🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mc.svg",
    dialCodes: ["+377"],
    slug: "monaco",
  },
  {
    name: "Mongolia",
    code: "MN",
    emoji: "🇲🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mn.svg",
    dialCodes: ["+976"],
    slug: "mongolia",
  },
  {
    name: "Montenegro",
    code: "ME",
    emoji: "🇲🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/me.svg",
    dialCodes: ["+382"],
    slug: "montenegro",
  },
  {
    name: "Montserrat",
    code: "MS",
    emoji: "🇲🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ms.svg",
    dialCodes: ["+1 664"],
    slug: "montserrat",
  },
  {
    name: "Morocco",
    code: "MA",
    emoji: "🇲🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ma.svg",
    dialCodes: ["+212"],
    slug: "morocco",
  },
  {
    name: "Mozambique",
    code: "MZ",
    emoji: "🇲🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mz.svg",
    dialCodes: ["+258"],
    slug: "mozambique",
  },
  {
    name: "Myanmar (Burma)",
    code: "MM",
    emoji: "🇲🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mm.svg",
    dialCodes: ["+95"],
    slug: "myanmar-(burma)",
  },
  {
    name: "Namibia",
    code: "NA",
    emoji: "🇳🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/na.svg",
    dialCodes: ["+264"],
    slug: "namibia",
  },
  {
    name: "Nauru",
    code: "NR",
    emoji: "🇳🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nr.svg",
    dialCodes: ["+674"],
    slug: "nauru",
  },
  {
    name: "Nepal",
    code: "NP",
    emoji: "🇳🇵",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/np.svg",
    dialCodes: ["+977"],
    slug: "nepal",
  },
  {
    name: "Netherlands",
    code: "NL",
    emoji: "🇳🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nl.svg",
    dialCodes: ["+31"],
    slug: "netherlands",
  },
  {
    name: "New Caledonia",
    code: "NC",
    emoji: "🇳🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nc.svg",
    dialCodes: ["+687"],
    slug: "new-caledonia",
  },
  {
    name: "New Zealand",
    code: "NZ",
    emoji: "🇳🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nz.svg",
    dialCodes: ["+64"],
    slug: "new-zealand",
  },
  {
    name: "Nicaragua",
    code: "NI",
    emoji: "🇳🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ni.svg",
    dialCodes: ["+505"],
    slug: "nicaragua",
  },
  {
    name: "Niger",
    code: "NE",
    emoji: "🇳🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ne.svg",
    dialCodes: ["+227"],
    slug: "niger",
  },
  {
    name: "Nigeria",
    code: "NG",
    emoji: "🇳🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ng.svg",
    dialCodes: ["+234"],
    slug: "nigeria",
  },
  {
    name: "Niue",
    code: "NU",
    emoji: "🇳🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nu.svg",
    dialCodes: ["+683"],
    slug: "niue",
  },
  {
    name: "Norfolk Island",
    code: "NF",
    emoji: "🇳🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/nf.svg",
    dialCodes: ["+672"],
    slug: "norfolk-island",
  },
  {
    name: "North Korea",
    code: "KP",
    emoji: "🇰🇵",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kp.svg",
    dialCodes: ["+850"],
    slug: "north-korea",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    emoji: "🇲🇵",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mp.svg",
    dialCodes: ["+1 670"],
    slug: "northern-mariana-islands",
  },
  {
    name: "Norway",
    code: "NO",
    emoji: "🇳🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/no.svg",
    dialCodes: ["+47"],
    slug: "norway",
  },
  {
    name: "Oman",
    code: "OM",
    emoji: "🇴🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/om.svg",
    dialCodes: ["+968"],
    slug: "oman",
  },
  {
    name: "Pakistan",
    code: "PK",
    emoji: "🇵🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pk.svg",
    dialCodes: ["+92"],
    slug: "pakistan",
  },
  {
    name: "Palau",
    code: "PW",
    emoji: "🇵🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pw.svg",
    dialCodes: ["+680"],
    slug: "palau",
  },
  {
    name: "Palestinian Territories",
    code: "PS",
    emoji: "🇵🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ps.svg",
    dialCodes: ["+970"],
    slug: "palestinian-territories",
  },
  {
    name: "Panama",
    code: "PA",
    emoji: "🇵🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pa.svg",
    dialCodes: ["+507"],
    slug: "panama",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    emoji: "🇵🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pg.svg",
    dialCodes: ["+675"],
    slug: "papua-new-guinea",
  },
  {
    name: "Paraguay",
    code: "PY",
    emoji: "🇵🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/py.svg",
    dialCodes: ["+595"],
    slug: "paraguay",
  },
  {
    name: "Peru",
    code: "PE",
    emoji: "🇵🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pe.svg",
    dialCodes: ["+51"],
    slug: "peru",
  },
  {
    name: "Philippines",
    code: "PH",
    emoji: "🇵🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ph.svg",
    dialCodes: ["+63"],
    slug: "philippines",
  },
  {
    name: "Pitcairn Islands",
    code: "PN",
    emoji: "🇵🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pn.svg",
    dialCodes: ["+64"],
    slug: "pitcairn-islands",
  },
  {
    name: "Poland",
    code: "PL",
    emoji: "🇵🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pl.svg",
    dialCodes: ["+48"],
    slug: "poland",
  },
  {
    name: "Portugal",
    code: "PT",
    emoji: "🇵🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pt.svg",
    dialCodes: ["+351"],
    slug: "portugal",
  },
  {
    name: "Puerto Rico",
    code: "PR",
    emoji: "🇵🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pr.svg",
    dialCodes: ["+1 787"],
    slug: "puerto-rico",
  },
  {
    name: "Qatar",
    code: "QA",
    emoji: "🇶🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/qa.svg",
    dialCodes: ["+974"],
    slug: "qatar",
  },
  {
    name: "Réunion",
    code: "RE",
    emoji: "🇷🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/re.svg",
    dialCodes: ["+262"],
    slug: "reunion",
  },
  {
    name: "Romania",
    code: "RO",
    emoji: "🇷🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ro.svg",
    dialCodes: ["+40"],
    slug: "romania",
  },
  {
    name: "Russia",
    code: "RU",
    emoji: "🇷🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ru.svg",
    dialCodes: ["+7"],
    slug: "russia",
  },
  {
    name: "Rwanda",
    code: "RW",
    emoji: "🇷🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/rw.svg",
    dialCodes: ["+250"],
    slug: "rwanda",
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    emoji: "🇧🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/bl.svg",
    slug: "saint-barthelemy",
  },
  {
    name: "Saint Helena",
    code: "SH",
    emoji: "🇸🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sh.svg",
    dialCodes: ["+290"],
    slug: "saint-helena",
  },
  {
    name: "Saint Kitts & Nevis",
    code: "KN",
    emoji: "🇰🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kn.svg",
    dialCodes: ["+1 869"],
    slug: "saint-kitts-and-nevis",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    emoji: "🇱🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lc.svg",
    dialCodes: ["+1 758"],
    slug: "saint-lucia",
  },
  {
    name: "Saint Martin",
    code: "MF",
    emoji: "🇲🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/mf.svg",
    slug: "saint-martin",
  },
  {
    name: "Saint Pierre & Miquelon",
    code: "PM",
    emoji: "🇵🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/pm.svg",
    dialCodes: ["+508"],
    slug: "saint-pierre-and-miquelon",
  },
  {
    name: "Samoa",
    code: "WS",
    emoji: "🇼🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ws.svg",
    dialCodes: ["+685"],
    slug: "samoa",
  },
  {
    name: "San Marino",
    code: "SM",
    emoji: "🇸🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sm.svg",
    dialCodes: ["+378"],
    slug: "san-marino",
  },
  {
    name: "Sao Tome & Principe",
    code: "ST",
    emoji: "🇸🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/st.svg",
    dialCodes: ["+239"],
    slug: "sao-tome-and-principe",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    emoji: "🇸🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sa.svg",
    dialCodes: ["+966"],
    slug: "saudi-arabia",
  },
  {
    name: "Senegal",
    code: "SN",
    emoji: "🇸🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sn.svg",
    dialCodes: ["+221"],
    slug: "senegal",
  },
  {
    name: "Serbia",
    code: "RS",
    emoji: "🇷🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/rs.svg",
    dialCodes: ["+381"],
    slug: "serbia",
  },
  {
    name: "Seychelles",
    code: "SC",
    emoji: "🇸🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sc.svg",
    dialCodes: ["+248"],
    slug: "seychelles",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    emoji: "🇸🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sl.svg",
    dialCodes: ["+232"],
    slug: "sierra-leone",
  },
  {
    name: "Singapore",
    code: "SG",
    emoji: "🇸🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sg.svg",
    dialCodes: ["+65"],
    slug: "singapore",
  },
  {
    name: "Sint Maarten",
    code: "SX",
    emoji: "🇸🇽",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sx.svg",
    dialCodes: ["+1 721"],
    slug: "sint-maarten",
  },
  {
    name: "Slovakia",
    code: "SK",
    emoji: "🇸🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sk.svg",
    dialCodes: ["+421"],
    slug: "slovakia",
  },
  {
    name: "Slovenia",
    code: "SI",
    emoji: "🇸🇮",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/si.svg",
    dialCodes: ["+386"],
    slug: "slovenia",
  },
  {
    name: "Solomon Islands",
    code: "SB",
    emoji: "🇸🇧",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sb.svg",
    dialCodes: ["+677"],
    slug: "solomon-islands",
  },
  {
    name: "Somalia",
    code: "SO",
    emoji: "🇸🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/so.svg",
    dialCodes: ["+252"],
    slug: "somalia",
  },
  {
    name: "South Africa",
    code: "ZA",
    emoji: "🇿🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/za.svg",
    dialCodes: ["+27"],
    slug: "south-africa",
  },
  {
    name: "South Georgia & South Sandwich Islands",
    code: "GS",
    emoji: "🇬🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gs.svg",
    slug: "south-georgia-and-south-sandwich-islands",
  },
  {
    name: "South Korea",
    code: "KR",
    emoji: "🇰🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/kr.svg",
    dialCodes: ["+82"],
    slug: "south-korea",
  },
  {
    name: "South Sudan",
    code: "SS",
    emoji: "🇸🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ss.svg",
    dialCodes: ["+211"],
    slug: "south-sudan",
  },
  {
    name: "Spain",
    code: "ES",
    emoji: "🇪🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/es.svg",
    dialCodes: ["+34"],
    slug: "spain",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    emoji: "🇱🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/lk.svg",
    dialCodes: ["+94"],
    slug: "sri-lanka",
  },
  {
    name: "Sudan",
    code: "SD",
    emoji: "🇸🇩",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sd.svg",
    dialCodes: ["+249"],
    slug: "sudan",
  },
  {
    name: "Suriname",
    code: "SR",
    emoji: "🇸🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sr.svg",
    dialCodes: ["+597"],
    slug: "suriname",
  },
  {
    name: "Svalbard & Jan Mayen",
    code: "SJ",
    emoji: "🇸🇯",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sj.svg",
    slug: "svalbard-and-jan-mayen",
  },
  {
    name: "Sweden",
    code: "SE",
    emoji: "🇸🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/se.svg",
    dialCodes: ["+46"],
    slug: "sweden",
  },
  {
    name: "Switzerland",
    code: "CH",
    emoji: "🇨🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ch.svg",
    dialCodes: ["+41"],
    slug: "switzerland",
  },
  {
    name: "Syria",
    code: "SY",
    emoji: "🇸🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/sy.svg",
    dialCodes: ["+963"],
    slug: "syria",
  },
  {
    name: "Taiwan",
    code: "TW",
    emoji: "🇹🇼",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tw.svg",
    dialCodes: ["+886"],
    slug: "taiwan",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    emoji: "🇹🇯",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tj.svg",
    dialCodes: ["+992"],
    slug: "tajikistan",
  },
  {
    name: "Tanzania",
    code: "TZ",
    emoji: "🇹🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tz.svg",
    dialCodes: ["+255"],
    slug: "tanzania",
  },
  {
    name: "Thailand",
    code: "TH",
    emoji: "🇹🇭",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/th.svg",
    dialCodes: ["+66"],
    slug: "thailand",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    emoji: "🇹🇱",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tl.svg",
    dialCodes: ["+670"],
    slug: "timor-leste",
  },
  {
    name: "Togo",
    code: "TG",
    emoji: "🇹🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tg.svg",
    dialCodes: ["+228"],
    slug: "togo",
  },
  {
    name: "Tokelau",
    code: "TK",
    emoji: "🇹🇰",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tk.svg",
    dialCodes: ["+690"],
    slug: "tokelau",
  },
  {
    name: "Tonga",
    code: "TO",
    emoji: "🇹🇴",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/to.svg",
    dialCodes: ["+676"],
    slug: "tonga",
  },
  {
    name: "Trinidad & Tobago",
    code: "TT",
    emoji: "🇹🇹",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tt.svg",
    dialCodes: ["+1 868"],
    slug: "trinidad-and-tobago",
  },
  {
    name: "Tunisia",
    code: "TN",
    emoji: "🇹🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tn.svg",
    dialCodes: ["+216"],
    slug: "tunisia",
  },
  {
    name: "Turkey",
    code: "TR",
    emoji: "🇹🇷",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tr.svg",
    dialCodes: ["+90"],
    slug: "turkey",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    emoji: "🇹🇲",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tm.svg",
    dialCodes: ["+993"],
    slug: "turkmenistan",
  },
  {
    name: "Turks & Caicos Islands",
    code: "TC",
    emoji: "🇹🇨",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tc.svg",
    dialCodes: ["+1 649"],
    slug: "turks-and-caicos-islands",
  },
  {
    name: "Tuvalu",
    code: "TV",
    emoji: "🇹🇻",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/tv.svg",
    dialCodes: ["+688"],
    slug: "tuvalu",
  },
  {
    name: "Uganda",
    code: "UG",
    emoji: "🇺🇬",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ug.svg",
    dialCodes: ["+256"],
    slug: "uganda",
  },
  {
    name: "Ukraine",
    code: "UA",
    emoji: "🇺🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ua.svg",
    dialCodes: ["+380"],
    slug: "ukraine",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    emoji: "🇦🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ae.svg",
    dialCodes: ["+971"],
    slug: "united-arab-emirates",
  },
  {
    name: "United Kingdom",
    code: "GB",
    emoji: "🇬🇧",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/gb.svg",
    dialCodes: ["+44"],
    slug: "united-kingdom",
  },
  {
    name: "United States",
    code: "US",
    emoji: "🇺🇸",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/us.svg",
    dialCodes: ["+1"],
    slug: "united-states",
  },
  {
    name: "Uruguay",
    code: "UY",
    emoji: "🇺🇾",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/uy.svg",
    dialCodes: ["+598"],
    slug: "uruguay",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    emoji: "🇺🇿",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/uz.svg",
    dialCodes: ["+998"],
    slug: "uzbekistan",
  },
  {
    name: "Vanuatu",
    code: "VU",
    emoji: "🇻🇺",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/vu.svg",
    dialCodes: ["+678"],
    slug: "vanuatu",
  },
  {
    name: "Vatican City",
    code: "VA",
    emoji: "🇻🇦",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/va.svg",
    dialCodes: ["+379"],
    slug: "vatican-city",
  },
  {
    name: "Venezuela",
    code: "VE",
    emoji: "🇻🇪",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/ve.svg",
    dialCodes: ["+58"],
    slug: "venezuela",
  },
  {
    name: "Vietnam",
    code: "VN",
    emoji: "🇻🇳",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/vn.svg",
    dialCodes: ["+84"],
    slug: "vietnam",
  },
  {
    name: "Wallis & Futuna",
    code: "WF",
    emoji: "🇼🇫",
    image:
      "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/wf.svg",
    dialCodes: ["+681"],
    slug: "wallis-and-futuna",
  },
];

export const countryDialCodes = (function () {
  let result = {};

  countries.forEach((country) => {
    result[country.code] = country.dialCodes?.join("");
  });

  return result;
})();

export const languages = {};
const languageEntries = Object.entries(languageEnum);
_.each(languageEntries, (lang) => {
  languages[lang[1]] = lang[0];
});

export const amenityFieldLabels = {
  hours: "Hours/Dates of Operation",
  temp: "Temperature",
  location: "Physical Location",
  password: "Password or Code",
  instructions: "Instructions",
  restrictions: "Restrictions",
  cost: "Cost or Free",
  special_note: "Special Note",
};

export const amenityTypeLabels = {
  child: "Child Amenities",
  baby: "Baby Amenities",
  bathroom: "Bathroom Amenities",
  kitchen: "Kitchen Amenities",
  services: "Services",
  office: "Office Amenities",
  local_services: "Local Services",
  parking: "Parking Amenities",
  basic: "Basic Amenities",
  safety: "Safety Amenities",
  indoor_amenities: "Indoor Amenities",
  cleaning: "Cleaning Amenities",
  view: "View Amenities",
  accessibility: "Accessibility Amenities",
  gear: "Gear Amenities",
  bedroom: "Bedroom Amenities",
  outdoor_amenities: "Outdoor Amenities",
  religious: "Religious Amenities",
  activities: "Activities",
};

export const amenityLabels = {
  atm_nearby: "ATM nearby",
  amenity_outdoor_shower: "Outdoor shower",
  "mounta in_climbing": "Mountain climbing",
  changing_table: "Changing table",
  baby_bath: "Baby bath",
  baby_crib: "Baby crib",
  baby_listening_device: "Baby listening device",
  baby_safety_gates: "Baby safety gates",
  baby_sitting: "Baby sitting",
  toddler_bed: "Toddler bed",
  playground_nearby: "Playground nearby",
  child_toddler_seat: "Child toddler seat",
  child_books_and_toys: "Child books and toys",
  child_dinnerware: "Child dinnerware",
  child_play_area: "Child play area",
  children_s_books_and_toys: "Children's books & toys",
  children_s_dinnerware: "Children's dinnerware",
  children_s_play_area: "Children's play area",
  children_s_playpen: "Children's playpen",
  children_s_pool: "Children's pool",
  bartender_on_request: "Bartender on request",
  bathrobe: "Bathrobe",
  bath_tub_with_spray_jets: "Bath tub with spray jets",
  bathtub: "Bathtub",
  butler: "Butler",
  shower: "Shower",
  hot_tub: "Hot tub",
  combo_tub_shower: "Combo tub shower",
  bathtub_and_whirlpool_separate: "Bathtub and whirlpool separate",
  plates_and_bowls: "Plates and bowls",
  oven: "Oven",
  freezer: "Freezer",
  ice_maker: "Ice maker",
  indoor_parking: "Indoor parking",
  outdoor_parking: "Outdoor parking",
  wifi: "Wifi",
  dishwasher: "Dishwasher",
  kitchen: "Kitchen",
  kitchenette: "Kitchenette",
  pizza_oven: "Pizza oven",
  raclette: "Raclette",
  electric_kettle: "Electric kettle",
  grill: "Grill",
  refrigerator: "Refrigerator",
  coffee_maker: "Coffee maker",
  coffee_or_tea_maker: "Coffee or tea maker",
  microwave: "Microwave",
  stove: "Stove",
  bar: "Bar",
  airport_shuttle: "Airport shuttle",
  luggage_service: "Luggage service",
  grocery_service: "Grocery service",
  room_service: "Room service",
  newspaper: "Newspaper",
  private_bartender: "Private bartender",
  private_butler: "Private butler",
  laundry_service: "Laundry service",
  pant_press: "Pant press",
  catering_services: "Catering services",
  photographer: "Photographer",
  door_man: "Door man",
  car_available: "Car available",
  concierge: "Concierge",
  staffed_property: "Staffed property",
  private_chef: "Private chef",
  dry_cleaning: "Dry cleaning",
  breakfast: "Breakfast",
  valet_parking: "Valet parking",
  welcome_drink: "Welcome drink",
  welcome_gift: "Welcome gift",
  wake_up_calls: "Wake up calls",
  chauffeur: "Chauffeur",
  events_ticket_service: "Events ticket service",
  emergency_support: "Emergency support",
  laundry_services: "Laundry services",
  business_center: "Business center",
  computer: "Computer",
  desk: "Desk",
  ethernet_connection: "Ethernet connection",
  fax_machine: "Fax machine",
  atm: "Atm",
  car_rental_desk: "Car rental desk",
  hospital: "Hospital",
  near_a_train_or_subway_station: "Near a train or subway station",
  market: "Market",
  coin_operated_laundry: "Coin operated laundry",
  currency_exchange: "Currency exchange",
  ski_rental: "Ski rental",
  electric_car_charging_stations: "Electric car charging stations",
  bicycle_rentals: "Bicycle rentals",
  gift_or_news_stand: "Gift or news stand",
  grocery_store: "Grocery store",
  secured_parking: "Secured parking",
  disabled_parking_spot: "Disabled parking spot",
  garage: "Garage",
  ev_charger: "Ev charger",
  duty_free_shop: "Duty free shop",
  grecian_tub: "Grecian tub",
  historic: "Historic",
  library: "Library",
  lounges_or_bars: "Lounges or bars",
  private_dock: "Private dock",
  heli_pad: "Heli pad",
  ipad: "Ipad",
  mini_refrigerator: "Mini refrigerator",
  mosquito_net: "Mosquito net",
  medical_facilities_service: "Medical facilities service",
  meeting_rooms: "Meeting rooms",
  minibar: "Minibar",
  mobile_or_cellular_phones: "Mobile or cellular phones",
  premium_linens_and_towels: "Premium linens and towels",
  spa_bathroom: "Spa bathroom",
  instant_hot_water: "Instant hot water",
  heating: "Heating",
  air_conditioning: "Air conditioning",
  hangers: "Hangers",
  smoke_detectors: "Smoke detectors",
  private_entrance: "Private entrance",
  private_bathroom: "Private bathroom",
  cooking_basics: "Cooking basics",
  silverware_or_utensils: "Silverware or utensils",
  telephone: "Telephone",
  soap_or_shampoo: "Soap or shampoo",
  fire_extinguishers: "Fire extinguishers",
  lock_on_bedroom_door: "Lock on bedroom door",
  soundproofed_room: "Soundproofed room",
  carbon_monoxide_detector: "Carbon monoxide detector",
  carbon_monoxide_detector_and_smoke_detector:
    "Carbon monoxide detector and smoke detector",
  security_system: "Security system",
  table_corner_guards: "Table corner guards",
  tables_and_chairs: "Tables and chairs",
  telephone_for_hearing_impaired: "Telephone for hearing impaired",
  outlet_covers: "Outlet covers",
  first_aid_kit: "First aid kit",
  dining_area: "Dining area",
  ceiling_fan: "Ceiling fan",
  closets_in_room: "Closets in room",
  dart_board: "Dart board",
  radio: "Radio",
  fitness_center: "Fitness center",
  home_theatre_system: "Home theatre system",
  safe: "Safe",
  futon: "Futon",
  snack_bar: "Snack bar",
  courtyard: "Courtyard",
  gym: "Gym",
  cd_player: "Cd player",
  couch: "Couch",
  billiards: "Billiards",
  solarium: "Solarium",
  table_tennis: "Table tennis",
  fireplace: "Fireplace",
  foosball: "Foosball",
  television: "Television",
  game_console: "Game console",
  video_games: "Video games",
  tiled_floor: "Tiled floor",
  stereo: "Stereo",
  toaster: "Toaster",
  tour_or_sightseeing_desk: "Tour or sightseeing desk",
  tourist_attractions: "Tourist attractions",
  trampoline: "Trampoline",
  vending_machines: "Vending machines",
  pool_table: "Pool table",
  iron: "Iron",
  washer: "Washer",
  dryer: "Dryer",
  ironing_board: "Ironing board",
  oversized_bathtub: "Oversized bathtub",
  marble_bathroom: "Marble bathroom",
  bidet: "Bidet",
  shared_bathroom: "Shared bathroom",
  towels: "Towels",
  hairdryer: "Hairdryer",
  steam_room: "Steam room",
  steam_bath: "Steam bath",
  slippers: "Slippers",
  rollin_shower_with_bench: "Rollin shower with bench",
  tub_with_shower_bench: "Tub with shower bench",
  sauna: "Sauna",
  ocean: "Ocean",
  ocean_view: "Ocean view",
  park_view: "Park view",
  harbor_view: "Harbor view",
  mountain_view: "Mountain view",
  beach_view: "Beach view",
  water_view: "Water view",
  garden_view: "Garden view",
  lake_view: "Lake view",
  river_view: "River view",
  waterfront: "Waterfront",
  riverfront: "Riverfront",
  beachfront: "Beachfront",
  oceanfront: "Oceanfront",
  lakefront: "Lakefront",
  seafront: "Seafront",
  fishing_bay: "Fishing bay",
  reef: "Reef",
  downtown: "Downtown",
  city_view: "City view",
  flat_smooth_pathway_to_front_door: "Flat smooth pathway to front door",
  home_step_free_access: "Home step free access",
  carpeted_floor: "Carpeted floor",
  parquet_floor: "Parquet floor",
  path_to_entrance_lit_at_night: "Path to entrance lit at night",
  limited_accessibility: "Limited accessibility",
  hypoallergenic_bed: "Hypoallergenic bed",
  hypoallergenic_rooms: "Hypoallergenic rooms",
  handheld_shower_hear: "Handheld shower hear",
  grab_rails_in_shower_and_toilet: "Grab rails in shower and toilet",
  nearby_local_nightlife: "Nearby local nightlife",
  bathroom_wide_doorway: "Bathroom wide doorway",
  bedroom_step_free_access: "Bedroom step free access",
  bedroom_wide_doorway: "Bedroom wide doorway",
  home_wide_doorway: "Home wide doorway",
  upper_floor_reachable_by_stairs_only: "Upper floor reachable by stairs only",
  bathroom_step_free_access: "Bathroom step free access",
  single_level_home: "Single level home",
  elevator: "Elevator",
  wheelchair_access: "Wheelchair access",
  wheelchair_inaccessible: "Wheelchair inaccessible",
  wide_clearance_to_bed: "Wide clearance to bed",
  wide_clearance_to_shower_and_toilet: "Wide clearance to shower and toilet",
  wide_hallway_clearance: "Wide hallway clearance",
  window_guards: "Window guards",
  beach_essentials: "Beach essentials",
  locker_room: "Locker room",
  ski_storage: "Ski storage",
  bike: "Bike",
  water_sports_gear: "Water sports gear",
  snow_sports_gear: "Snow sports gear",
  luxury_linen_type: "Luxury linen type",
  foam_pillows: "Foam pillows",
  room_darkening_shades: "Room darkening shades",
  extra_pillows_and_blankets: "Extra pillows and blankets",
  alarm_clock: "Alarm clock",
  linens: "Linens",
  patio: "Patio",
  outdoor_shower: "Outdoor shower",
  outdoor_dining_area: "Outdoor dining area",
  squash_court: "Squash court",
  outdoor_furniture: "Outdoor furniture",
  hammock: "Hammock",
  fire_pit: "Fire pit",
  private_yard: "Private yard",
  garden: "Garden",
  summer_terrace: "Summer terrace",
  plunge_pool: "Plunge pool",
  pool: "Swimming Pool",
  barbeque: "Barbeque",
  gazebo: "Gazebo",
  wood_stove: "Wood stove",
  basketball_court: "Basketball court",
  near_ocean: "Near ocean",
  balcony: "Balcony",
  breakfast_included_in_price: "Breakfast included in price",
  dishes_utensils: "Dishes utensils",
  family: "Family",
  fitness_room: "Fitness room",
  house_cleaning_included: "House cleaning included",
  music_library: "Music library",
  satellite_or_cable: "Satellite or cable",
  veranda: "Veranda",
  synagogue: "Synagogue",
  church: "Church",
  boating: "Boating",
  hunting: "Hunting",
  ice_skating: "Ice skating",
  restaurant: "Restaurant",
  hot_air_ballooning: "Hot air ballooning",
  sailing: "Sailing",
  miniature_golf: "Miniature golf",
  gambling: "Gambling",
  racquetball: "Racquetball",
  hiking_trail: "Hiking trail",
  movie_theater: "Movie theater",
  live_entertainment: "Live entertainment",
  jacuzzi: "Jacuzzi",
  jet_ski: "Jet ski",
  kayaking: "Kayaking",
  canoeing: "Canoeing",
  tennis: "Tennis",
  museum: "Museum",
  ruins: "Ruins",
  picnic_area: "Picnic area",
  walking_track: "Walking track",
  horseback_riding: "Horseback riding",
  casino: "Casino",
  resort: "Resort",
  cave: "Cave",
  bowling_alley: "Bowling alley",
  diving: "Diving",
  tennis_court: "Tennis court",
  rain_forest: "Rain forest",
  disco: "Disco",
  recreation_center: "Recreation center",
  bird_watching: "Bird watching",
  fishing: "Fishing",
  hiking: "Hiking",
  antiquing: "Antiquing",
  zoo: "Zoo",
  health_beauty_spa: "Health beauty spa",
  marina: "Marina",
  mountaineering: "Mountaineering",
  museums: "Museums",
  windsurfing: "Windsurfing",
  water_skiing: "Water skiing",
  surfing: "Surfing",
  shopping: "Shopping",
  cross_country_skiing: "Cross country skiing",
  massage: "Massage",
  nude_beach: "Nude beach",
  nightclub: "Nightclub",
  kayak: "Kayak",
  water_parks: "Water parks",
  whitewater_rafting: "Whitewater rafting",
  wildlife_viewing: "Wildlife viewing",
  winery_tours: "Winery tours",
  volcano: "Volcano",
  theme_parks: "Theme parks",
  skiing: "Skiing",
  cycling: "Cycling",
  spelunking: "Spelunking",
  swimming: "Swimming",
  rafting: "Rafting",
  scuba_or_snorkeling: "Scuba or snorkeling",
  thalassotherapy: "Thalassotherapy",
  tubing: "Tubing",
  whale_watching: "Whale watching",
  golfing: "Golfing",
  snow_boarding: "Snow boarding",
  snowmobiling: "Snowmobiling",
  river_rafting: "River rafting",
  sledding: "Sledding",
  rock_climbing: "Rock climbing",
  paddle_boating: "Paddle boating",
  parasailing: "Parasailing",
  mountain_biking_trail: "Mountain biking trail",
  mountain_climbing: "Mountain climbing",
  water_park: "Water park",
};

export const guestViewsUrlMap = {
  all_guests: {
    redirect_url: buildGuestFilterUrl(
      [],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "guest_ai_summary",
      ],
    ),
    title: "All",
    iconName: "users",
    description: "See every guest you've had stay with you.",
  },
  direct_bookings: {
    redirect_url: buildGuestFilterUrl(
      [{id: "booking_channel", value: "Direct Booking"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "booking_channel",
      ],
    ),
    title: "Direct bookings",
    iconName: "home",
    description: "Guests who booked directly.",
  },
  happy_guests: {
    redirect_url: buildGuestFilterUrl(
      [{id: "rating", value: "Satisfied"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "guest_ai_summary",
        "rating",
      ],
    ),
    title: "Happy Guests",
    iconName: "smile",
    description: "All of your happiest guests!",
  },
  unhappy_guests: {
    redirect_url: buildGuestFilterUrl(
      [{id: "rating", value: "Unsatisfied"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_ai_summary",
        "guest_destination",
        "rating",
      ],
    ),
    title: "Unhappy Guests",
    icon: <SentimentDissatisfiedRounded style={{fontSize: 40}} />,
    description: "All of your least happy guests.",
  },
  top_spenders: {
    redirect_url: buildGuestFilterUrl(
      [{id: "total_rev", value: "Above $3,000"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "total_rev",
      ],
    ),
    title: "Top Spenders",
    icon: <MoneyRounded style={{fontSize: 40}} />,
    description: "All of your top spending guests.",
  },
  top_upsell_spenders: {
    redirect_url: buildGuestFilterUrl(
      [{id: "enso_total_revenue", value: "Above $100"}],
      [
        "guest_purchased_product_names",
        "guest_purchased_product_types",
        "total_rev",
        "guest_name",
        "guest_destination",
        "enso_total_revenue",
      ],
    ),
    title: "Top Upsells Spenders",
    icon: <ArrowUpwardRounded style={{fontSize: 40}} />,
    description: "Guests who have spent the most on upsells.",
  },
  topic_complaint: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Complaint"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Complaints",
    icon: <SentimentDissatisfiedRounded style={{fontSize: 40}} />,
    description: "Guests who have complained.",
  },
  topic_amenity_question: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Amenity Question"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Amenity Questions",
    iconName: "help-circle",
    description: "Questions regarding amenities.",
  },
  topic_refund_request: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Refund Request"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Refund Requests",
    iconName: "dollar-sign",
    description: "Guests requesting refunds.",
  },
  topic_checkin_checkout_request: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Check-in/out Request"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Check-in/out Requests",
    iconName: "check-in",
    description: "Guests requesting check-in or check-out.",
  },
  topic_checkin_checkout_question: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Check-in/Check-out question"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Check-in/out Questions",
    iconName: "unlock",
    description: "Guests asking about check-in or check-out.",
  },
  topic_special_accommodations: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Special Accommodations Request"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Special Accommodations Requests",
    iconName: "home",
    description: "Guests requesting special accommodations.",
  },
  topic_stay_alteration_request: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Stay Alteration Request"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Stay Alteration Requests",
    iconName: "settings-tune",
    description: "Guests requesting stay alterations.",
  },
  topic_positive_feedback: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Positive Feedback"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Positive Feedback",
    iconName: "thumbs-up",
    description: "Guests leaving positive feedback.",
  },
  topic_transportation: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Transportation"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Transportation Requests",
    iconName: "truck",
    description: "Guests requesting transportation information.",
  },
  topic_local_recommendations: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Local Recommendations"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Local Recommendations",
    iconName: "globe",
    description: "Guests asking for local recommendations.",
  },
  topic_verification_question: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Verification Question"}],
      [
        "guest_name",
        "guest_email",
        "guest_phone",
        "guest_destination",
        "message_topics",
        "guest_ai_summary",
      ],
    ),
    title: "Verification Questions",
    iconName: "check-circle",
    description: "Guests asking verification questions.",
  },
  topic_other: {
    redirect_url: buildGuestFilterUrl(
      [{id: "message_topics", value: "Other"}],
      [
        "guest_name",
        "message_topics",
        "guest_ai_summary",
        "guest_email",
        "guest_phone",
        "guest_destination",
      ],
    ),
    title: "Other",
    iconName: "help-circle",
    description: "Other miscellaneous requests.",
  },
};

/* Handles the non-custom field column options (just field enum value) */
export const crmGuestTableColumns = [
  "guest_name",
  "message_topics",
  "guest_ai_summary",
  "rating",
  "enso_total_revenue",
  "total_rev",
  "guest_purchased_product_names",
  "guest_purchased_product_types",
  "guest_email",
  "listing_state",
  "listing_city",
  "guest_phone",
  "guest_destination",
  "booking_star_rating",
  "guest_destination",
  "guest_location",
];

export const crmV2NewFields = [
  "guest_purchased_product_names",
  "guest_purchased_product_types",
  "enso_total_revenue",
  "message_topics",
];

export const guideBookIcons = [
  {label: "Home", icon: <Home />},
  {label: "WiFi", icon: <Wifi />},
  {label: "Parking", icon: <LocalParking />},
  {label: "Dining", icon: <Restaurant />},
  {label: "Coffee", icon: <LocalCafe />},
  {label: "Shopping", icon: <ShoppingCart />},
  {label: "Gym", icon: <FitnessCenter />},
  {label: "Pool", icon: <Pool />},
  {label: "Laundry", icon: <LocalLaundryService />},
  {label: "Check-in", icon: <MeetingRoom />},
  {label: "Check-out", icon: <ExitToApp />},
  {label: "Map", icon: <Map />},
  {label: "Transport", icon: <DirectionsCar />},
  {label: "Public Transit", icon: <DirectionsBus />},
  {label: "Emergency Contacts", icon: <Phone />},
  {label: "Rules", icon: <Gavel />},
  {label: "Info", icon: <Info />},
  {label: "Health", icon: <LocalHospital />},
  {label: "Safety", icon: <Security />},
  {label: "Pet Friendly", icon: <Pets />},
  {label: "Smoking Policy", icon: <SmokingRooms />},
  {label: "No Smoking", icon: <SmokeFree />},
  {label: "TV", icon: <Tv />},
  {label: "Air Conditioning", icon: <AcUnit />},
  {label: "Heating", icon: <Whatshot />},
  {label: "Accessibility", icon: <Accessible />},
  {label: "Beach Access", icon: <BeachAccess />},
  {label: "Bicycle Rentals", icon: <DirectionsBike />},
  {label: "Local Events", icon: <Event />},
  {label: "Local Pharmacy", icon: <LocalPharmacy />},
  {label: "Banking/ATM", icon: <AccountBalance />},
  {label: "Music/Entertainment", icon: <MusicNote />},
  {label: "Bar/Nightlife", icon: <LocalBar />},
  {label: "Taxi Services", icon: <LocalTaxi />},
  {label: "Playground", icon: <ChildCare />},
  {label: "Garden/Yard", icon: <NaturePeople />},
  {label: "BBQ", icon: <OutdoorGrill />},
  {label: "Key Access", icon: <VpnKey />},
  {label: "Spa", icon: <Spa />},
  {label: "Alarm/Security", icon: <Alarm />},
  {label: "Dining Options", icon: <Fastfood />},
  {label: "Hiking Trails", icon: <Terrain />},
  {label: "Library/Book Exchange", icon: <LibraryBooks />},
  {label: "Local Guide", icon: <PersonPin />},
  {label: "Luggage Storage", icon: <WorkOutline />},
  {label: "Weather", icon: <WbSunny />},
];

export const defaultFieldMap = {
  checkbox: "CheckBoxField",
  text: "TextField",
  single_select: "MultiSelectField",
  multi_select: "MultiSelectField",
  number: "DigitField",
  image: "image",
  date: "DateField",
  local_date: "LocalDateField",
  time: "TimeField",
  time_offset: "TimeOffsetField",
  range: "IntegerRangeField",
};

export const relativeDatesMap = {
  "Last Week": ["relative_date_last_week_start", "relative_date_last_week_end"],
  Yesterday: ["relative_date_yesterday_start", "relative_date_yesterday_end"],
  Today: ["relative_date_today_start", "relative_date_today_end"],
  Tomorrow: ["relative_date_tomorrow_start", "relative_date_tomorrow_end"],
  "This Week": ["relative_date_this_week_start", "relative_date_this_week_end"],
  "This Month": [
    "relative_date_this_month_start",
    "relative_date_this_month_end",
  ],
  "This Year": ["relative_date_this_year_start", "relative_date_this_year_end"],
};

export const hiddenRelativeDatesMap = {
  ...relativeDatesMap,

  "Today or earlier": ["relative_date_today_end", "relative_date_year_ago"],
  "Today or later": [
    "relative_date_today_start",
    "relative_date_year_from_now",
  ],
};
